export enum TEST_ELEMENT_IDS {
	KYC_REVIEW_CERTIFICATION_PANEL = 'KYC_REVIEW_CERTIFICATION_PANEL',
	KYC_REVIEW_CERTIFICATION_RESEND = 'KYC_REVIEW_CERTIFICATION_RESEND',
	KYC_REVIEW_VIEW_ORIGINAL_TOGGLE = 'KYC_REVIEW_VIEW_ORIGINAL_TOGGLE',
	LEFT_PANEL = 'LEFT_PANEL',
	RIGHT_PANEL = 'RIGHT_PANEL',
	PAGE_HEADER = 'PAGE_HEADER',
	TOGGLE_PANEL_ICON = 'TOGGLE_PANEL_ICON',
	TREE = 'TREE',
	BLOCK_NODE = 'BLOCK_NODE',
	DEAL_DASHBOARD_CAP_TABLE_TILE = 'DEAL_DASHBOARD_CAP_TABLE_TILE',
	DEAL_DASHBOARD_CAP_CHART_TILE = 'DEAL_DASHBOARD_CAP_CHART_TILE',
	DEAL_DASHBOARD_DOCUMENT_LIBRARY_TILE = 'DEAL_DASHBOARD_DOCUMENT_LIBRARY_TILE',
	DEAL_DASHBOARD_VALUATION_TILE = 'DEAL_DASHBOARD_VALUATION_TILE',
	DEAL_DASHBOARD_EVENT_LOG_TILE = 'DEAL_DASHBOARD_EVENT_LOG_TILE',
	AUTO_SAVER_INDICATOR = 'AUTO_SAVER_INDICATOR',
	NEW_ENTITY_CELL = 'NEW_ENTITY_CELL',
	NEW_DEFAULT_CELL = 'NEW_DEFAULT_CELL',
	EXPANDABLE_COUNTER_TAG_CELL = 'EXPANDABLE_COUNTER_TAG_CELL',
	EXPANDABLE_COUNTER_TAG_CELL_NAME = 'EXPANDABLE_COUNTER_TAG_CELL_NAME',
	EXPANDABLE_COUNTER_TAG_CELL_BADGE = 'EXPANDABLE_COUNTER_TAG_CELL_BADGE',
	EXPANDABLE_COUNTER_TAG_CELL_EXPAND_BTN = 'EXPANDABLE_COUNTER_TAG_CELL_EXPAND_BTN',
	NEW_ENTITY_CELL_TOGGLE = 'NEW_ENTITY_CELL_TOGGLE',
	DELETE_ACTION_CELL = 'DELETE_ACTION_CELL',
	DEFAULT_HEADER_CELL = 'DEFAULT_HEADER_CELL',
	DEFAULT_TOGGLE_HEADER_CELL = 'DEFAULT_TOGGLE_HEADER_CELL',
	BADGE_MULTI_SELECT = 'BADGE_MULTI_SELECT',
	OVERFLOW_BADGE_LIST = 'OVERFLOW_BADGE_LIST',
	OVERFLOW_BADGE = 'OVERFLOW_BADGE',
	OVERFLOW_REMOVE = 'OVERFLOW_REMOVE',
	BREADCRUMB_DROPDOWN = 'BREADCRUMB_DROPDOWN',
	BREADCRUMB_DROPDOWN_NEW_INVESTMENT_PROGRAMME = 'BREADCRUMB_DROPDOWN_NEW_INVESTMENT_PROGRAMME',
	GENERIC_ERROR_SIGN_OUT_BUTTON = 'GENERIC_ERROR_SIGN_OUT_BUTTON',
	SESSION_ENDED_CONTINUE_BUTTON = 'SESSION_ENDED_CONTINUE_BUTTON',
	LINK_EXPIRED_NOTICE = 'LINK_EXPIRED_NOTICE',
	LINK_EXPIRED_CONTINUE_BUTTON = 'LINK_EXPIRED_CONTINUE_BUTTON',
	INVITATION_EXPIRED_PAGE = 'INVITATION_EXPIRED_PAGE',
	INVITATION_EXPIRED_RENEW_BUTTON = 'INVITATION_EXPIRED_RENEW_BUTTON',
	INVITATION_EXPIRED_SIGN_IN_BUTTON = 'INVITATION_EXPIRED_SIGN_IN_BUTTON',
	LOGIN_PAGE_EMAIL_INPUT = 'LOGIN_PAGE_EMAIL_INPUT',
	LOGIN_PAGE_PASSWORD_INPUT = 'LOGIN_PAGE_PASSWORD_INPUT',
	LOGIN_PAGE_SUBMIT_BUTTON = 'LOGIN_PAGE_SUBMIT_BUTTON',
	LOGIN_PAGE_BACK_BUTTON = 'LOGIN_PAGE_BACK_BUTTON',
	LOGIN_PAGE_FORGOT_YOUR_PASSWORD_BUTTON = 'LOGIN_PAGE_FORGOT_YOUR_PASSWORD_BUTTON',
	RESET_PASSWORD_EMAIL_INPUT = 'RESET_PASSWORD_EMAIL_INPUT',
	RESET_PASSWORD_BUTTON = 'RESET_PASSWORD_BUTTON',
	RESET_PASSWORD_RESEND_BUTTON = 'RESET_PASSWORD_RESEND_BUTTON',
	NEW_PASSWORD_INPUT = 'NEW_PASSWORD_INPUT',
	RESET_PASSWORD_BACK_BUTTON = 'RESET_PASSWORD_BACK_BUTTON',
	RESET_PASSWORD_RE_ENTER_EMAIL = 'RESET_PASSWORD_RE_ENTER_EMAIL',
	NEW_PASSWORD_HINT = 'NEW_PASSWORD_HINT',
	MAIN_LAYOUT_USER_DROPDOWN = 'MAIN_LAYOUT_USER_DROPDOWN',
	MAIN_LAYOUT_USER_DROPDOWN_USER_PROFILE = 'MAIN_LAYOUT_USER_DROPDOWN_USER_PROFILE',
	MAIN_LAYOUT_USER_DROPDOWN_HELP = 'MAIN_LAYOUT_USER_DROPDOWN_HELP',
	MAIN_LAYOUT_USER_DROPDOWN_LOGOUT = 'MAIN_LAYOUT_USER_DROPDOWN_LOGOUT',
	MAIN_LAYOUT_USER_DROPDOWN_ORGANIZATION = 'MAIN_LAYOUT_USER_DROPDOWN_ORGANIZATION',
	MAIN_LAYOUT_USER_DROPDOWN_DOCUMENT_TEMPLATES = 'MAIN_LAYOUT_USER_DROPDOWN_DOCUMENT_TEMPLATES',
	ADMIN_DASHBOARD_PAGE_CREATE_PROJECT_BUTTON = 'ADMIN_DASHBOARD_PAGE_CREATE_PROJECT_BUTTON',
	ADMIN_DASHBOARD_PAGE_WELCOME_NAME = 'ADMIN_DASHBOARD_PAGE_WELCOME_NAME',
	ADMIN_DASHBOARD_PAGE_CREATE_PROJECT_MODAL_DEAL_NAME_INPUT = 'ADMIN_DASHBOARD_PAGE_CREATE_PROJECT_MODAL_DEAL_NAME_INPUT',
	ADMIN_DASHBOARD_PAGE_CREATE_PROJECT_MODAL_TARGET_NAME_INPUT = 'ADMIN_DASHBOARD_PAGE_CREATE_PROJECT_MODAL_TARGET_NAME_INPUT',
	ADMIN_DASHBOARD_PAGE_CREATE_PROJECT_MODAL_DEFAULT_CURRENCY = 'ADMIN_DASHBOARD_PAGE_CREATE_PROJECT_MODAL_DEFAULT_CURRENCY',
	ADMIN_DASHBOARD_PAGE_CREATE_PROJECT_MODAL_INTERNAL_DEAL_TAG = 'ADMIN_DASHBOARD_PAGE_CREATE_PROJECT_MODAL_INTERNAL_DEAL_TAG',
	ADMIN_DASHBOARD_PAGE_CREATE_PROJECT_MODAL_ORGANIZATION = 'ADMIN_DASHBOARD_PAGE_CREATE_PROJECT_MODAL_ORGANIZATION',
	ADMIN_DASHBOARD_PAGE_CREATE_PROJECT_MODAL_SUBMIT_BUTTON = 'ADMIN_DASHBOARD_PAGE_CREATE_PROJECT_MODAL_SUBMIT_BUTTON',
	ADMIN_DASHBOARD_PAGE_DEAL_BLOCK = 'ADMIN_DASHBOARD_PAGE_DEAL_BLOCK',
	ADMIN_LOADER = 'ADMIN_LOADER',
	FULLSCREEN_LOADER = 'FULLSCREEN_LOADER',
	DEAL_DASHBOARD_DIRECTORY_TILE = 'DEAL_DASHBOARD_DIRECTORY_TILE',
	MIP_MANAGE_KYC_REVIEW_ACCEPT_BUTTON = 'MIP_MANAGE_KYC_REVIEW_ACCEPT_BUTTON',
	MIP_MANAGE_KYC_REVIEW_NEXT_BUTTON = 'MIP_MANAGE_KYC_REVIEW_NEXT_BUTTON',
	MIP_MANAGE_KYC_REVIEW_COMPLETE_BUTTON = 'MIP_MANAGE_KYC_REVIEW_COMPLETE_BUTTON',
	MIP_MANAGE_KYC_REVIEW_REJECT_BUTTON = 'MIP_MANAGE_KYC_REVIEW_REJECT_BUTTON',
	MIP_MANAGE_KYC_REVIEW_REJECT_COMMENT_INPUT = 'MIP_MANAGE_KYC_REVIEW_REJECT_COMMENT_INPUT',
	MIP_MANAGE_KYC_REVIEW_REJECT_CONFIRM_BUTTON = 'MIP_MANAGE_KYC_REVIEW_REJECT_CONFIRM_BUTTON',
	MIP_MANAGE_KYC_REVIEW_UPDATE_DECISION_BUTTON = 'MIP_MANAGE_KYC_REVIEW_UPDATE_DECISION_BUTTON',
	MIP_MANAGE_KYC_REVIEW_AWAITING_SIGNATURE_HINT = 'MIP_MANAGE_KYC_REVIEW_AWAITING_SIGNATURE_HINT',
	ADMIN_DASHBOARD_PAGE_PROJECT_MODAL_ADD_NEW_MIP_BUTTON = 'ADMIN_DASHBOARD_PAGE_PROJECT_MODAL_ADD_NEW_MIP_BUTTON',
	ADMIN_DASHBOARD_PAGE_PROJECT_MODAL_ADD_NEW_INVESTMENT_PROGRAMME_BUTTON = 'ADMIN_DASHBOARD_PAGE_PROJECT_MODAL_ADD_NEW_INVESTMENT_PROGRAMME_BUTTON',
	ADMIN_DASHBOARD_PAGE_PROJECT_QUICK_CREATE_MIP_OPTION = 'ADMIN_DASHBOARD_PAGE_PROJECT_QUICK_CREATE_MIP_OPTION',
	ADMIN_DASHBOARD_PAGE_PROJECT_CONFIGURE_MIP_OPTION = 'ADMIN_DASHBOARD_PAGE_PROJECT_CONFIGURE_MIP_OPTION',
	ADMIN_DASHBOARD_PAGE_PROJECT_MODAL_DELETE_DEAL_INPUT = 'ADMIN_DASHBOARD_PAGE_PROJECT_MODAL_DELETE_DEAL_INPUT',
	ADMIN_DASHBOARD_PAGE_PROJECT_MODAL_DELETE_DEAL_CONFIRM_BUTTON = 'ADMIN_DASHBOARD_PAGE_PROJECT_MODAL_DELETE_DEAL_CONFIRM_BUTTON',
	ADMIN_DASHBOARD_CONFIRMATION_MODAL_CANCEL_BUTTON = 'ADMIN_DASHBOARD_CONFIRMATION_MODAL_CANCEL_BUTTON',
	ADMIN_DASHBOARD_CONFIRMATION_MODAL_CONTINUE_BUTTON = 'ADMIN_DASHBOARD_CONFIRMATION_MODAL_CONTINUE_BUTTON',
	ADMIN_MIP_CARDS = 'ADMIN_MIP_CARDS',
	ADMIN_SUMMARY_ITEM_NAME = 'ADMIN_SUMMARY_ITEM_NAME',
	ADMIN_SUMMARY_ITEM_VALUE = 'ADMIN_SUMMARY_ITEM_VALUE',
	ADMIN_DEAL_PAGE_DEAL_NAME = 'ADMIN_DEAL_PAGE_DEAL_NAME',
	ADMIN_DEAL_PAGE_SETTINGS_TILE = 'ADMIN_DEAL_PAGE_SETTINGS_TILE',
	ADMIN_DEAL_SETTINGS_PAGE_UPDATE_BUTTON = 'ADMIN_DEAL_SETTINGS_PAGE_UPDATE_BUTTON',
	ADMIN_DEAL_SETTINGS_PAGE_DELETE_BUTTON = 'ADMIN_DEAL_SETTINGS_PAGE_DELETE_BUTTON',
	VESTING_TERMS_EXPANDABLE_PANEL = 'VESTING_TERMS_EXPANDABLE_PANEL',
	VESTING_TERMS_STRAIGHT_LINE_TOGGLE = 'VESTING_TERMS_STRAIGHT_LINE_TOGGLE',
	VESTING_TERMS_TIME_UNIT_DROPDOWN = 'VESTING_TERMS_TIME_UNIT_DROPDOWN',
	VESTING_TERMS_INTERVAL_INPUT = 'VESTING_TERMS_INTERVAL_INPUT',
	VESTING_TERMS_PERIOD_INPUT = 'VESTING_TERMS_PERIOD_INPUT',
	VESTING_TERMS_CLIFF_INPUT = 'VESTING_TERMS_CLIFF_INPUT',
	VESTING_TERMS_CANCEL_BUTTON = 'VESTING_TERMS_CANCEL_BUTTON',
	VESTING_TERMS_SAVE_BUTTON = 'VESTING_TERMS_SAVE_BUTTON',
	CAP_SIDEBAR = 'CAP_SIDEBAR',
	CAP_DEAL_DIRECTORY_CREATE_ENTITY = 'CAP_DEAL_DIRECTORY_CREATE_ENTITY',
	CAP_DEAL_DIRECTORY_CREATE_LEGAL_PERSON = 'CAP_DEAL_DIRECTORY_CREATE_LEGAL_PERSON',
	CAP_DEAL_DIRECTORY_CREATE_LEGAL_PERSON_NAME_INPUT = 'CAP_DEAL_DIRECTORY_CREATE_LEGAL_PERSON_NAME_INPUT',
	CAP_DEAL_DIRECTORY_PERSON_NAME = 'CAP_DEAL_DIRECTORY_PERSON_NAME',
	CAP_DEAL_DIRECTORY_CREATE_LEGAL_PERSON_SUBMIT_BUTTON = 'CAP_DEAL_DIRECTORY_CREATE_LEGAL_PERSON_SUBMIT_BUTTON',
	CAP_DEAL_DIRECTORY_CREATE_NATURAL_PERSON = 'CAP_DEAL_DIRECTORY_CREATE_NATURAL_PERSON',
	CAP_DEAL_DIRECTORY_CREATE_NATURAL_PERSON_FIRST_NAME_INPUT = 'CAP_DEAL_DIRECTORY_CREATE_NATURAL_PERSON_FIRST_NAME_INPUT',
	CAP_DEAL_DIRECTORY_CREATE_NATURAL_PERSON_LAST_NAME_INPUT = 'CAP_DEAL_DIRECTORY_CREATE_NATURAL_PERSON_LAST_NAME_INPUT',
	CAP_DEAL_DIRECTORY_CREATE_NATURAL_PERSON_SUBMIT_BUTTON = 'ADMIN_DEAL_DIRECTORY_CREATE_LEGAL_NATURAL_SUBMIT_BUTTON',
	CAP_ADDRESS_FORM_HOUSE_NUMBER_INPUT = 'CAP_ADDRESS_FORM_HOUSE_NUMBER_INPUT',
	CAP_ADDRESS_FORM_STREET_INPUT = 'CAP_ADDRESS_FORM_STREET_INPUT',
	CAP_ADDRESS_FORM_CITY_INPUT = 'CAP_ADDRESS_FORM_CITY_INPUT',
	CAP_ADDRESS_FORM_POST_CODE_INPUT = 'CAP_ADDRESS_FORM_POST_CODE_INPUT',
	CAP_ADDRESS_FORM_COUNTRY_SELECT = 'CAP_ADDRESS_FORM_COUNTRY_SELECT',
	CAP_ADDRESS_FORM_TAGS_MULTISELECT = 'CAP_ADDRESS_FORM_TAGS_MULTISELECT',
	CAP_ADDRESS_FORM_SUBMIT_BUTTON = 'CAP_ADDRESS_FORM_SUBMIT_BUTTON',
	CAP_ADDRESS_DRAWER_HEADING = 'CAP_ADDRESS_DRAWER_HEADING',
	CAP_TAX_INFO_FORM_MANUAL_MODE_BUTTON = 'CAP_TAX_INFO_FORM_MANUAL_MODE_BUTTON',
	CAP_TAX_INFO_FORM_COUNTRY_SELECT = 'CAP_TAX_INFO_FORM_COUNTRY_SELECT',
	CAP_TAX_INFO_FORM_NUMBER_INPUT = 'CAP_TAX_INFO_FORM_NUMBER_INPUT',
	CAP_TAX_INFO_FORM_NUMBER_TYPE_INPUT = 'CAP_TAX_INFO_FORM_NUMBER_TYPE_INPUT',
	CAP_TAX_INFO_FORM_SUBMIT_BUTTON = 'CAP_TAX_INFO_FORM_SUBMIT_BUTTON',
	CAP_TAX_INFO_DRAWER_HEADING = 'CAP_TAX_INFO_DRAWER_HEADING',
	CAP_BANK_ACCOUNT_DRAWER_HEADING = 'CAP_BANK_ACCOUNT_DRAWER_HEADING',
	CAP_EMPLOYMENT_RECORD_DRAWER_HEADING = 'CAP_EMPLOYMENT_RECORD_DRAWER_HEADING',
	CAP_EMPLOYMENT_RECORD_FORM_EMPLOYER_SELECT = 'CAP_EMPLOYMENT_RECORD_FORM_EMPLOYER_SELECT',
	// Suffixed by employer display name — employer names are stable, unlike translated labels.
	CAP_EMPLOYMENT_RECORD_FORM_EMPLOYER_OPTION = 'CAP_EMPLOYMENT_RECORD_FORM_EMPLOYER_OPTION',
	CAP_EMPLOYMENT_RECORD_FORM_JOB_TITLE_INPUT = 'CAP_EMPLOYMENT_RECORD_FORM_JOB_TITLE_INPUT',
	CAP_EMPLOYMENT_RECORD_FORM_START_DATE_INPUT = 'CAP_EMPLOYMENT_RECORD_FORM_START_DATE_INPUT',
	CAP_EMPLOYMENT_RECORD_FORM_END_DATE_INPUT = 'CAP_EMPLOYMENT_RECORD_FORM_END_DATE_INPUT',
	CAP_EMPLOYMENT_RECORD_FORM_EMPLOYEE_REFERENCE_INPUT = 'CAP_EMPLOYMENT_RECORD_FORM_EMPLOYEE_REFERENCE_INPUT',
	CAP_EMPLOYMENT_RECORD_FORM_PRIMARY_CHECKBOX = 'CAP_EMPLOYMENT_RECORD_FORM_PRIMARY_CHECKBOX',
	CAP_EMPLOYMENT_RECORD_FORM_SUBMIT_BUTTON = 'CAP_EMPLOYMENT_RECORD_FORM_SUBMIT_BUTTON',
	CAP_SIDEBAR_SEARCH_INPUT = 'CAP_SIDEBAR_SEARCH_INPUT',
	CAP_SIDEBAR_PERSONS_LIST_CONTAINER = 'CAP_SIDEBAR_PERSONS_LIST_CONTAINER',
	CAP_SIDEBAR_PERSON_PIN_BUTTON = 'CAP_SIDEBAR_PERSON_PIN_BUTTON',
	CAP_SIDEBAR_CLASSIFIER_FILTER_TAB = 'CAP_SIDEBAR_CLASSIFIER_FILTER_TAB',
	CAP_CLASSIFIERS_TAG_BADGE = 'CAP_CLASSIFIERS_TAG_BADGE',
	CAP_CLASSIFIERS_TAGS_MULTISELECT = 'CAP_CLASSIFIERS_TAGS_MULTISELECT',
	CAP_REGISTRATION_DETAILS_JURISDICTION_SELECT = 'CAP_REGISTRATION_DETAILS_JURISDICTION_SELECT',
	CAP_REGISTRATION_DETAILS_JURISDICTION_LANGUAGE_SELECT = 'CAP_REGISTRATION_DETAILS_JURISDICTION_LANGUAGE_SELECT',
	CAP_REGISTRATION_DETAILS_LEGAL_FORM_SELECT = 'CAP_REGISTRATION_DETAILS_LEGAL_FORM_SELECT',
	CAP_REGISTRATION_DETAILS_NUMBER_INPUT = 'CAP_REGISTRATION_DETAILS_NUMBER_INPUT',
	CAP_BASIC_DETAILS_DOB_INPUT = 'CAP_BASIC_DETAILS_DOB_INPUT',
	CAP_BASIC_DETAILS_POB_INPUT = 'CAP_BASIC_DETAILS_POB_INPUT',
	CAP_BASIC_DETAILS_COUNTRY_OF_BIRTH_SELECT = 'CAP_BASIC_DETAILS_COUNTRY_OF_BIRTH_SELECT',
	CAP_BASIC_DETAILS_CITIZENSHIP_MULTISELECT = 'CAP_BASIC_DETAILS_CITIZENSHIP_MULTISELECT',
	CAP_BASIC_DETAILS_DOMICILE_SELECT = 'CAP_BASIC_DETAILS_DOMICILE_SELECT',
	CAP_BASIC_DETAILS_EMAIL_INPUT = 'CAP_BASIC_DETAILS_EMAIL_INPUT',
	CAP_BASIC_DETAILS_EMAIL_VALUE = 'CAP_BASIC_DETAILS_EMAIL_VALUE',
	CAP_BASIC_DETAILS_EMAIL_LINKED_INDICATOR = 'CAP_BASIC_DETAILS_EMAIL_LINKED_INDICATOR',
	CAP_ADDRESS_TILE = 'CAP_ADDRESS_TILE',
	CAP_BANK_ACCOUNT_TILE = 'CAP_BANK_ACCOUNT_TILE',
	CAP_EMPLOYMENT_RECORD_TILE = 'CAP_EMPLOYMENT_RECORD_TILE',
	// Only rendered when the record is the employee's primary; one primary per employee.
	CAP_EMPLOYMENT_RECORD_TILE_PRIMARY_BADGE = 'CAP_EMPLOYMENT_RECORD_TILE_PRIMARY_BADGE',
	CAP_TAX_INFO_TILE = 'CAP_TAX_INFO_TILE',
	CAP_INVESTMENT_PROGRAMMES_ROW = 'CAP_INVESTMENT_PROGRAMMES_ROW',
	CAP_INVESTMENT_PROGRAMMES_ROW_NAME = 'CAP_INVESTMENT_PROGRAMMES_ROW_NAME',
	CAP_INVESTMENT_PROGRAMMES_ROW_UNLINK_BUTTON = 'CAP_INVESTMENT_PROGRAMMES_ROW_UNLINK_BUTTON',
	CAP_INVESTMENT_PROGRAMMES_LINK_DRAWER_MIP_SELECT = 'CAP_INVESTMENT_PROGRAMMES_LINK_DRAWER_MIP_SELECT',
	CAP_INVESTMENT_PROGRAMMES_LINK_DRAWER_MIP_OPTION = 'CAP_INVESTMENT_PROGRAMMES_LINK_DRAWER_MIP_OPTION',
	CAP_INVESTMENT_PROGRAMMES_LINK_DRAWER_TRANSACTIONS_CHECKBOX = 'CAP_INVESTMENT_PROGRAMMES_LINK_DRAWER_TRANSACTIONS_CHECKBOX',
	CAP_INVESTMENT_PROGRAMMES_LINK_DRAWER_SUBMIT_BUTTON = 'CAP_INVESTMENT_PROGRAMMES_LINK_DRAWER_SUBMIT_BUTTON',
	CAP_INVESTMENT_PROGRAMMES_UNLINK_DRAWER_TRANSACTIONS_CHECKBOX = 'CAP_INVESTMENT_PROGRAMMES_UNLINK_DRAWER_TRANSACTIONS_CHECKBOX',
	CAP_INVESTMENT_PROGRAMMES_UNLINK_DRAWER_TSA_WARNING = 'CAP_INVESTMENT_PROGRAMMES_UNLINK_DRAWER_TSA_WARNING',
	CAP_INVESTMENT_PROGRAMMES_UNLINK_DRAWER_SUBMIT_BUTTON = 'CAP_INVESTMENT_PROGRAMMES_UNLINK_DRAWER_SUBMIT_BUTTON',
	CAP_RELATED_PEOPLE_ROW = 'CAP_RELATED_PEOPLE_ROW',
	CAP_RELATED_PEOPLE_ROW_EDIT_BUTTON = 'CAP_RELATED_PEOPLE_ROW_EDIT_BUTTON',
	CAP_RELATED_PEOPLE_ROW_DELETE_BUTTON = 'CAP_RELATED_PEOPLE_ROW_DELETE_BUTTON',
	CAP_RELATED_PEOPLE_DRAWER_RELATION_SELECT = 'CAP_RELATED_PEOPLE_DRAWER_RELATION_SELECT',
	CAP_RELATED_PEOPLE_DRAWER_RELATION_OPTION = 'CAP_RELATED_PEOPLE_DRAWER_RELATION_OPTION',
	CAP_RELATED_PEOPLE_DRAWER_PERSON_SELECT = 'CAP_RELATED_PEOPLE_DRAWER_PERSON_SELECT',
	CAP_RELATED_PEOPLE_DRAWER_PERSON_OPTION = 'CAP_RELATED_PEOPLE_DRAWER_PERSON_OPTION',
	CAP_RELATED_PEOPLE_DRAWER_CUSTOM_ROLE_INPUT = 'CAP_RELATED_PEOPLE_DRAWER_CUSTOM_ROLE_INPUT',
	CAP_RELATED_PEOPLE_DRAWER_LEGAL_REP_YES = 'CAP_RELATED_PEOPLE_DRAWER_LEGAL_REP_YES',
	CAP_RELATED_PEOPLE_DRAWER_LEGAL_REP_NO = 'CAP_RELATED_PEOPLE_DRAWER_LEGAL_REP_NO',
	CAP_RELATED_PEOPLE_DRAWER_SUBMIT_BUTTON = 'CAP_RELATED_PEOPLE_DRAWER_SUBMIT_BUTTON',
	CAP_EDIT_RELATED_PERSON_DRAWER_RELATION_SELECT = 'CAP_EDIT_RELATED_PERSON_DRAWER_RELATION_SELECT',
	CAP_EDIT_RELATED_PERSON_DRAWER_CUSTOM_ROLE_INPUT = 'CAP_EDIT_RELATED_PERSON_DRAWER_CUSTOM_ROLE_INPUT',
	CAP_EDIT_RELATED_PERSON_DRAWER_SUBMIT_BUTTON = 'CAP_EDIT_RELATED_PERSON_DRAWER_SUBMIT_BUTTON',
	// Legal-person side of the related-people section (RelatedPersonsSection); the
	// natural side uses CAP_RELATED_PEOPLE_ROW above. Suffixed `${relationType}_${personId}`
	// — one person can hold two relation types on the same entity, so personId alone collides.
	CAP_RELATED_PERSONS_ROW = 'CAP_RELATED_PERSONS_ROW',
	CAP_RELATED_PERSONS_ROW_DELETE_BUTTON = 'CAP_RELATED_PERSONS_ROW_DELETE_BUTTON',
	CAP_RELATED_PERSONS_ROW_TYPE_BADGE = 'CAP_RELATED_PERSONS_ROW_TYPE_BADGE',
	EDITABLE_TILE_EDIT_BUTTON = 'EDITABLE_TILE_EDIT_BUTTON',
	EDITABLE_TILE_DELETE_BUTTON = 'EDITABLE_TILE_DELETE_BUTTON',
	EDITABLE_INFO_CONTAINER_EDIT_BUTTON = 'EDITABLE_INFO_CONTAINER_EDIT_BUTTON',
	EDITABLE_INFO_CONTAINER_UPDATE_BUTTON = 'EDITABLE_INFO_CONTAINER_UPDATE_BUTTON',
	CAP_DEAL_DIRECTORY_SECTION_ADD_TRIGGER = 'CAP_DEAL_DIRECTORY_SECTION_ADD_TRIGGER',
	CAP_REGISTRATION_DETAILS_JURISDICTION_OPTION = 'CAP_REGISTRATION_DETAILS_JURISDICTION_OPTION',
	CAP_REGISTRATION_DETAILS_JURISDICTION_LANGUAGE_OPTION = 'CAP_REGISTRATION_DETAILS_JURISDICTION_LANGUAGE_OPTION',
	CAP_REGISTRATION_DETAILS_LEGAL_FORM_OPTION = 'CAP_REGISTRATION_DETAILS_LEGAL_FORM_OPTION',
	CAP_COUNTRY_OPTION = 'CAP_COUNTRY_OPTION',
	CAP_ADDRESS_FORM_TAG_OPTION = 'CAP_ADDRESS_FORM_TAG_OPTION',
	CAP_CLASSIFIERS_TAG_OPTION = 'CAP_CLASSIFIERS_TAG_OPTION',
	CAP_TAB_SECURITIES = 'CAP_TAB_SECURITIES',
	CAP_BACK_TO_SECURITIES_BUTTON = 'CAP_BACK_TO_SECURITIES_BUTTON',
	CAP_TAB_TRANSACTIONS = 'CAP_TAB_TRANSACTIONS',
	CAP_ADD_SECURITY_BUTTON = 'CAP_ADD_SECURITY_BUTTON',
	CAP_ADD_MANAGE_RANKING_BUTTON = 'CAP_ADD_MANAGE_RANKING_BUTTON',
	// Enables nominee structures on the entity whose Securities tab is open.
	CAP_ENTITY_NOMINEE_STRUCTURE_TOGGLE = 'CAP_ENTITY_NOMINEE_STRUCTURE_TOGGLE',
	DEAL_NOMINEE_STRUCTURE_CARD = 'DEAL_NOMINEE_STRUCTURE_CARD',
	DEAL_NOMINEE_STRUCTURE_TOGGLE = 'DEAL_NOMINEE_STRUCTURE_TOGGLE',
	MANTINE_TABLE_QUICK_FILTER_SELECT = 'MANTINE_TABLE_QUICK_FILTER_SELECT',
	CAP_BULK_ACTIONS_MENU_BUTTON = 'CAP_BULK_ACTIONS_MENU_BUTTON',
	CAP_BULK_ACTIONS_MENU_CLOSE_BUTTON = 'CAP_BULK_ACTIONS_MENU_CLOSE_BUTTON',
	CAP_TABLE_PAGINATION_ROWS_PER_PAGE_TEXT = 'CAP_TABLE_PAGINATION_ROWS_PER_PAGE_TEXT',
	CAP_TABLE_SELECT_ALL_ON_PAGE_CHECKBOX = 'CAP_TABLE_SELECT_ALL_ON_PAGE_CHECKBOX',
	CAP_SECURITIES_DOWNLOAD_FILTERED = 'CAP_SECURITIES_DOWNLOAD_FILTERED',
	CAP_SECURITIES_DOWNLOAD_SELECTED = 'CAP_SECURITIES_DOWNLOAD_SELECTED',
	CAP_CREATE_SECURITY_TYPE_SELECT = 'CAP_CREATE_SECURITY_TYPE_SELECT',
	CAP_CREATE_SECURITY_NAME_INPUT = 'CAP_CREATE_SECURITY_NAME_INPUT',
	CAP_CREATE_SECURITY_CURRENCY_SELECT = 'CAP_CREATE_SECURITY_CURRENCY_SELECT',
	CAP_CREATE_SECURITY_SUBMIT_BUTTON = 'CAP_CREATE_SECURITY_SUBMIT_BUTTON',
	CAP_SECURITY_ROW_OPEN_BUTTON = 'CAP_SECURITY_ROW_OPEN_BUTTON',
	SECURITY_EDIT_DRAWER_NAME_INPUT = 'SECURITY_EDIT_DRAWER_NAME_INPUT',
	SECURITY_EDIT_DRAWER_SAVE_BUTTON = 'SECURITY_EDIT_DRAWER_SAVE_BUTTON',
	SECURITY_EDIT_DRAWER_VIEW_MORE_BUTTON = 'SECURITY_EDIT_DRAWER_VIEW_MORE_BUTTON',
	SECURITY_EDIT_DRAWER_DELETE_BUTTON = 'SECURITY_EDIT_DRAWER_DELETE_BUTTON',
	MIP_PROGRAMME_SECURITY_ADD_BUTTON = 'MIP_PROGRAMME_SECURITY_ADD_BUTTON',
	MIP_PROGRAMME_SECURITY_EDIT_BUTTON = 'MIP_PROGRAMME_SECURITY_EDIT_BUTTON',
	CAP_TAB_EVENTS = 'CAP_TAB_EVENTS',
	CAP_NEW_EVENT_BUTTON = 'CAP_NEW_EVENT_BUTTON',
	CAP_EVENT_DATE_INPUT = 'CAP_EVENT_DATE_INPUT',
	CAP_EVENT_TYPE_SELECT = 'CAP_EVENT_TYPE_SELECT',
	CAP_EVENT_POST_UNITS_INPUT = 'CAP_EVENT_POST_UNITS_INPUT',
	CAP_EVENT_PRE_UNITS_INPUT = 'CAP_EVENT_PRE_UNITS_INPUT',
	CAP_EVENT_CONVERSION_SELECT = 'CAP_EVENT_CONVERSION_SELECT',
	CAP_EVENT_CREATE_BUTTON = 'CAP_EVENT_CREATE_BUTTON',
	CAP_CREATE_AUTHORISED_CAPITAL_BUTTON = 'CAP_CREATE_AUTHORISED_CAPITAL_BUTTON',
	CAP_CREATE_CATCH_UP_RIGHTS_BUTTON = 'CAP_CREATE_CATCH_UP_RIGHTS_BUTTON',
	CAP_CREATE_EXCHANGE_RIGHTS_BUTTON = 'CAP_CREATE_EXCHANGE_RIGHTS_BUTTON',
	CAP_CATCH_UP_RIGHTS_BASIS_SELECT = 'CAP_CATCH_UP_RIGHTS_BASIS_SELECT',
	CAP_CATCH_UP_RIGHTS_TARGET_INPUT = 'CAP_CATCH_UP_RIGHTS_TARGET_INPUT',
	CAP_AUTHORISED_CAPITAL_AUTHORISED_CAPITAL_INPUT = 'CAP_AUTHORISED_CAPITAL_AUTHORISED_CAPITAL_INPUT',
	CAP_CREATE_INCOME_RIGHTS_BUTTON = 'CAP_CREATE_INCOME_RIGHTS_BUTTON',
	CAP_CREATE_INCOME_RIGHTS_TRACKING_BUTTON = 'CAP_CREATE_INCOME_RIGHTS_TRACKING_BUTTON',
	CAP_INCOME_RIGHTS_RATE_INPUT = 'CAP_INCOME_RIGHTS_RATE_INPUT',
	CAP_INCOME_RIGHTS_ACC_PERIOD_SELECT = 'CAP_INCOME_RIGHTS_ACC_PERIOD_SELECT',
	CAP_INCOME_RIGHTS_SENIORITY_INCOME_INPUT = 'CAP_INCOME_RIGHTS_SENIORITY_INCOME_INPUT',
	CAP_INCOME_RIGHTS_DAY_CONVENTION = 'CAP_INCOME_RIGHTS_DAY_CONVENTION',
	CAP_INCOME_RIGHTS_SENIORITY_RANK_INTEREST_INPUT = 'CAP_INCOME_RIGHTS_SENIORITY_RANK_INTEREST_INPUT',
	CAP_INCOME_RIGHTS_SENIORITY_RANK_PRINCIPAL_INPUT = 'CAP_INCOME_RIGHTS_SENIORITY_RANK_PRINCIPAL_INPUT',
	CAP_INCOME_RIGHTS_PRINCIPAL_TYPE = 'CAP_INCOME_RIGHTS_PRINCIPAL_TYPE',
	CAP_INCOME_RIGHTS_PRINCIPAL_VALUE = 'CAP_INCOME_RIGHTS_PRINCIPAL_VALUE',

	CAP_INCOME_RIGHTS_DEEMED_START_DATE_INPUT = 'CAP_INCOME_RIGHTS_DEEMED_START_DATE_INPUT',
	CAP_INCOME_RIGHTS_COMPOUNDING_PERIOD_SELECT = 'CAP_INCOME_RIGHTS_COMPOUNDING_PERIOD_SELECT',
	CAP_INCOME_RIGHTS_FIRST_INTEREST_DATE_INPUT = 'CAP_INCOME_RIGHTS_FIRST_INTEREST_DATE_INPUT',
	CAP_CREATE_REDEMPTION_RIGHTS_BUTTON = 'CAP_CREATE_REDEMPTION_RIGHTS_BUTTON',
	CAP_CREATE_PARTICIPATION_THRESHOLD_BUTTON = 'CAP_CREATE_PARTICIPATION_THRESHOLD_BUTTON',
	CAP_CREATE_RATCHETING_BUTTON = 'CAP_CREATE_RATCHETING_BUTTON',
	CAP_SECURITY_DETAILS_PAGE_CONTAINER = 'CAP_SECURITY_DETAILS_PAGE_CONTAINER',
	CAP_SECURITY_RANKING_PAGE_CONTAINER = 'CAP_SECURITY_RANKING_PAGE_CONTAINER',
	CAP_RANKING_ADD_RANK_BUTTON = 'CAP_RANKING_ADD_RANK_BUTTON',
	CAP_RANK_CONTAINER = 'CAP_RANK_CONTAINER',
	CAP_RANK_MOVE_UP_BUTTON = 'CAP_RANK_MOVE_UP_BUTTON',
	CAP_RANK_MOVE_DOWN_BUTTON = 'CAP_RANK_MOVE_DOWN_BUTTON',
	CAP_RANK_NAME_INPUT = 'CAP_RANK_NAME_INPUT',
	CAP_RANK_NAME_TEXT = 'CAP_RANK_NAME_TEXT',
	CAP_RANK_REMOVE_BUTTON = 'CAP_RANK_REMOVE_BUTTON',
	CAP_SECURITY_RANK_CARD = 'CAP_SECURITY_RANK_CARD',
	CAP_SECURITY_RANK_CARD_RATCHET_INDICATOR = 'CAP_SECURITY_RANK_CARD_RATCHET_INDICATOR',
	CAP_SECURITY_UNRANK_BUTTON = 'CAP_SECURITY_UNRANK_BUTTON',
	CAP_SECURITY_SPLIT_BUTTON = 'CAP_SECURITY_SPLIT_BUTTON',
	CAP_SECURITY_MERGE_BUTTON = 'CAP_SECURITY_MERGE_BUTTON',
	CAP_SECURITY_DETAILS_EDIT_BUTTON = 'CAP_SECURITY_DETAILS_EDIT_BUTTON',
	CAP_SECURITY_DETAILS_EDIT_SAVE_BUTTON = 'CAP_SECURITY_DETAILS_EDIT_SAVE_BUTTON',
	CAP_SECURITY_DETAILS_EDIT_RESIDUE_RIGHTS_TOGGLE = 'CAP_SECURITY_DETAILS_EDIT_RESIDUE_RIGHTS_TOGGLE',
	CAP_RATCHETING_EDIT_BUTTON = 'CAP_RATCHETING_EDIT_BUTTON',
	CAP_RATCHETING_DISTRIBUTE_UNTIL_BREAKPOINT_TOGGLE = 'CAP_RATCHETING_DISTRIBUTE_UNTIL_BREAKPOINT_TOGGLE',
	CAP_RATCHETING_DISTRIBUTE_UNTIL_BREAKPOINT_VALUE = 'CAP_RATCHETING_DISTRIBUTE_UNTIL_BREAKPOINT_VALUE',
	CAP_SECURITY_DETAILS_EDIT_INCLUDE_IN_RETURNS_TOGGLE = 'CAP_SECURITY_DETAILS_EDIT_INCLUDE_IN_RETURNS_TOGGLE',
	CAP_SECURITY_DETAILS_EDIT_FRACTIONAL_TOGGLE = 'CAP_SECURITY_DETAILS_EDIT_FRACTIONAL_TOGGLE',
	CAP_SECURITY_DETAILS_EDIT_FRACTIONAL_DROPDOWN = 'CAP_SECURITY_DETAILS_EDIT_FRACTIONAL_DROPDOWN',
	CAP_SECURITY_DETAILS_FRACTIONAL_DENOMINATOR = 'CAP_SECURITY_DETAILS_FRACTIONAL_DENOMINATOR',
	CAP_SECURITY_DETAILS_FRACTIONAL_DROPDOWN_OPTION = 'CAP_SECURITY_DETAILS_FRACTIONAL_DROPDOWN_OPTION-',
	CAP_SECURITY_DETAILS_FEATURE_ROW_UPDATE_BUTTON = 'CAP_SECURITY_DETAILS_FEATURE_ROW_UPDATE_BUTTON',
	// SecurityWarningModal action buttons. Their labels come from Tolgee, so tests must
	// target these ids rather than translated copy.
	CAP_SECURITY_WARNING_MODAL_REVERT_BUTTON = 'CAP_SECURITY_WARNING_MODAL_REVERT_BUTTON',
	CAP_SECURITY_WARNING_MODAL_CONFIRM_BUTTON = 'CAP_SECURITY_WARNING_MODAL_CONFIRM_BUTTON',
	CAP_SECURITY_WARNING_MODAL_CLOSE_BUTTON = 'CAP_SECURITY_WARNING_MODAL_CLOSE_BUTTON',
	CAP_SECURITY_UPDATE_CURRENCY_OLD_FIELD = 'CAP_SECURITY_UPDATE_CURRENCY_OLD_FIELD',
	CAP_SECURITY_UPDATE_CURRENCY_NEW_FIELD = 'CAP_SECURITY_UPDATE_CURRENCY_NEW_FIELD',
	CAP_ADD_TRANSACTION_BUTTON = 'CAP_ADD_TRANSACTION_BUTTON',
	CAP_TRANSACTION_DOWNLOAD_SELECTED = 'CAP_TRANSACTION_DOWNLOAD_SELECTED',
	CAP_TRANSACTION_BULK_UPDATE_TYPE = 'CAP_TRANSACTION_BULK_UPDATE_TYPE',
	CAP_TRANSACTION_BULK_UPDATE_SELLER = 'CAP_TRANSACTION_BULK_UPDATE_SELLER',
	CAP_TRANSACTION_BULK_UPDATE_BUYER = 'CAP_TRANSACTION_BULK_UPDATE_BUYER',
	CAP_TRANSACTION_BULK_UPDATE_TYPE_SELECT = 'CAP_TRANSACTION_BULK_UPDATE_TYPE_SELECT',
	CAP_TRANSACTION_BULK_UPDATE_SELLER_SELECT = 'CAP_TRANSACTION_BULK_UPDATE_SELLER_SELECT',
	CAP_TRANSACTION_BULK_UPDATE_BUYER_SELECT = 'CAP_TRANSACTION_BULK_UPDATE_BUYER_SELECT',
	CAP_TRANSACTION_BULK_UPDATE_BUYER_MIP = 'CAP_TRANSACTION_BULK_UPDATE_BUYER_MIP',
	CAP_TRANSACTION_BULK_UPDATE_BUYER_MIP_SELECT = 'CAP_TRANSACTION_BULK_UPDATE_BUYER_MIP_SELECT',
	CAP_TRANSACTION_BULK_UPDATE_SUBMIT = 'CAP_TRANSACTION_BULK_UPDATE_SUBMIT',
	CAP_TRANSACTION_CREATE_DATE_INPUT = 'CAP_TRANSACTION_CREATE_DATE_INPUT',
	CAP_TRANSACTION_CREATE_SECURITY_SELECT = 'CAP_TRANSACTION_CREATE_SECURITY_SELECT',
	CAP_TRANSACTION_CREATE_TYPE_SELECT = 'CAP_TRANSACTION_CREATE_TYPE_SELECT',
	CAP_TRANSACTION_CREATE_BUYER_SELECT = 'CAP_TRANSACTION_CREATE_BUYER_SELECT',
	CAP_TRANSACTION_CREATE_BUYER_HOLDING = 'CAP_TRANSACTION_CREATE_BUYER_HOLDING',
	CAP_TRANSACTION_CREATE_SELLER_SELECT = 'CAP_TRANSACTION_CREATE_SELLER_SELECT',
	CAP_TRANSACTION_CREATE_NUMBER_INPUT = 'CAP_TRANSACTION_CREATE_NUMBER_INPUT',
	CAP_TRANSACTION_CREATE_PRICE_INPUT = 'CAP_TRANSACTION_CREATE_PRICE_INPUT',
	CAP_TRANSACTION_CREATE_SUBMIT_ADD_ANOTHER = 'CAP_TRANSACTION_CREATE_SUBMIT_ADD_ANOTHER',
	CAP_TRANSACTION_CREATE_SUBMIT = 'CAP_TRANSACTION_CREATE_SUBMIT',
	CAP_TRANSACTION_CREATE_NOMINEE_SAME_TOGGLE = 'CAP_TRANSACTION_CREATE_NOMINEE_SAME_TOGGLE',
	CAP_TRANSACTION_CREATE_NOMINEE_SELECT = 'CAP_TRANSACTION_CREATE_NOMINEE_SELECT',
	CAP_TRANSACTION_CREATE_BOUGHT_FOR_SELECT = 'CAP_TRANSACTION_CREATE_BOUGHT_FOR_SELECT',
	CAP_TRANSACTION_CREATE_TRANSFER_INTEREST_SELECT = 'CAP_TRANSACTION_CREATE_TRANSFER_INTEREST_SELECT',
	CAP_TRANSACTION_REDEMPTION_COUNTERPART_PANEL = 'CAP_TRANSACTION_REDEMPTION_COUNTERPART_PANEL',
	CAP_TRANSACTION_CREATE_REDEMPTION_INTEREST_SELECT = 'CAP_TRANSACTION_CREATE_REDEMPTION_INTEREST_SELECT',
	CAP_TRANSACTION_INSEPARABLE_REDEMPTION_PROCEED = 'CAP_TRANSACTION_INSEPARABLE_REDEMPTION_PROCEED',
	CAP_TRANSACTION_EDIT_TRANSFER_INTEREST_SELECT = 'CAP_TRANSACTION_EDIT_TRANSFER_INTEREST_SELECT',
	CAP_TRANSACTION_TABLE_INVALID_FILTER = 'CAP_TRANSACTION_TABLE_INVALID_FILTER',
	CAP_TRANSACTION_REORDER_INTEREST_FILTER = 'CAP_TRANSACTION_REORDER_INTEREST_FILTER',
	CAP_TRANSACTION_REORDER_TABLE = 'CAP_TRANSACTION_REORDER_TABLE',
	CAP_TRANSACTION_ROW_ACTIONS_BUTTON = 'CAP_TRANSACTION_ROW_ACTIONS_BUTTON',
	CAP_TRANSACTION_ROW_REORDER_ACTION = 'CAP_TRANSACTION_ROW_REORDER_ACTION',
	CAP_TRANSACTION_TABLE = 'CAP_TRANSACTION_TABLE',
	CAP_TRANSACTION_DETAILS_DOCUMENTS_TAB = 'CAP_TRANSACTION_DETAILS_DOCUMENTS_TAB',
	CAP_TRANSACTION_DOCUMENTS_ADD_NEW_BUTTON = 'CAP_TRANSACTION_DOCUMENTS_ADD_NEW_BUTTON',
	CAP_TRANSACTION_CREATE_CONVERSION_TARGET_SECURITY_SELECT = 'CAP_TRANSACTION_CREATE_CONVERSION_TARGET_SECURITY_SELECT',
	CAP_OWNERSHIP_TAB = 'CAP_OWNERSHIP_TAB',
	CAP_OWNERSHIP_DOWNLOAD_XLSX_BUTTON = 'CAP_OWNERSHIP_DOWNLOAD_XLSX_BUTTON',
	CAP_OWNERSHIP_DOWNLOAD_CSV_BUTTON = 'CAP_OWNERSHIP_DOWNLOAD_CSV_BUTTON',
	CAP_OWNERSHIP_DOWNLOAD_SHARE_REGISTER_BUTTON = 'CAP_OWNERSHIP_DOWNLOAD_SHARE_REGISTER_BUTTON',
	CAP_OWNERSHIP_VIEW_SWITCH = 'CAP_OWNERSHIP_VIEW_SWITCH',
	CAP_OWNERSHIP_HIDDEN_DATE_INPUT = 'CAP_OWNERSHIP_HIDDEN_DATE_INPUT',
	CAP_OWNERSHIP_TABLE_BODY = 'CAP_OWNERSHIP_TABLE_BODY',
	CAP_TABLE_SETTINGS_BUTTON = 'CAP_TABLE_SETTINGS_BUTTON',
	CAP_TABLE_SETTINGS_DETAIL_ITEM = 'CAP_TABLE_SETTINGS_DETAIL_ITEM',
	CAP_TABLE_EXPORT_MENU_BUTTON = 'CAP_TABLE_EXPORT_MENU_BUTTON',
	CAP_TABLE_DOWNLOAD_XLSX_BUTTON = 'CAP_TABLE_DOWNLOAD_XLSX_BUTTON',
	CAP_TABLE_DOWNLOAD_CSV_BUTTON = 'CAP_TABLE_DOWNLOAD_CSV_BUTTON',
	CAP_TABLE_DOWNLOAD_JSON_BUTTON = 'CAP_TABLE_DOWNLOAD_JSON_BUTTON',
	CAP_TABLE_GROUP_STRUCTURE_CHART_DOWNLOAD_PNG_BUTTON = 'CAP_TABLE_GROUP_STRUCTURE_CHART_DOWNLOAD_PNG_BUTTON',
	CAP_SELECTION_HEADER = 'CAP_SELECTION_HEADER',
	CAP_SELECTION_COUNT_DISPLAY = 'CAP_SELECTION_COUNT_DISPLAY',
	CAP_SELECTION_TOGGLE_SWITCH = 'CAP_SELECTION_TOGGLE_SWITCH',
	CAP_PARTICIPATION_THRESHOLD_BASIS_SELECT = 'CAP_PARTICIPATION_THRESHOLD_BASIS_SELECT',
	CAP_PARTICIPATION_THRESHOLD_TIER_INPUT = 'CAP_PARTICIPATION_THRESHOLD_TIER_INPUT',
	GSC_SETTINGS_BUTTON = 'GSC_SETTINGS_BUTTON',
	GSC_SETTINGS_NUMBER_FORMAT_SELECT = 'GSC_SETTINGS_NUMBER_FORMAT_SELECT',
	GSC_NODE_DATA = 'GSC_NODE_DATA',
	GSC_EDGE_LABEL = 'GSC_EDGE_LABEL',
	GSC_EDGE_LABEL_UNITS = 'GSC_EDGE_LABEL_UNITS',
	GSC_EDGE_LABEL_VOTES = 'GSC_EDGE_LABEL_VOTES',
	MIP_CREATE_HELP_MODAL_PREV_ARROW = 'MIP_CREATE_HELP_MODAL_PREV_ARROW',
	MIP_CREATE_HELP_MODAL_NEXT_ARROW = 'MIP_CREATE_HELP_MODAL_NEXT_ARROW',
	MIP_CREATE_HELP_MODAL_TAB = 'MIP_CREATE_HELP_MODAL_TAB',
	MIP_CREATE_HELP_BUTTON = 'MIP_CREATE_HELP_BUTTON',
	MIP_CREATE_NEXT_BUTTON = 'MIP_CREATE_NEXT_BUTTON',
	MIP_CREATE_SAVE_DRAFT_BUTTON = 'MIP_CREATE_SAVE_DRAFT_BUTTON',
	MIP_CREATE_BACK_BUTTON = 'MIP_CREATE_BACK_BUTTON',
	MIP_CREATE_CONTINUE_BUTTON = 'MIP_CREATE_CONTINUE_BUTTON',
	MIP_CREATE_NOTIFICATION_BOX = 'MIP_CREATE_NOTIFICATION_BOX',
	MIP_CREATE_GENERAL_DEAL_INPUTS_ENTITY_SELECT = 'MIP_CREATE_GENERAL_DEAL_INPUTS_ENTITY_SELECT',
	MIP_CREATE_GENERAL_DEAL_INPUTS_ENTITY_CREATE_NEW = 'MIP_CREATE_GENERAL_DEAL_INPUTS_ENTITY_CREATE_NEW',
	MIP_CREATE_GENERAL_DEAL_INPUTS_PROGRAMME_NAME_INPUT = 'MIP_CREATE_GENERAL_DEAL_INPUTS_PROGRAMME_NAME_INPUT',
	COMPONENT_IBAN_INPUTS = 'COMPONENT_IBAN_INPUTS',
	BANK_ACCOUNT_FORM = 'BANK_ACCOUNT_FORM',
	MIP_CREATE_PERSONAL_DATA_INDIVIDUAL_INVESTORS_BANK_ACCOUNT_DETAILS_CHECKBOX = 'MIP_CREATE_PERSONAL_DATA_INDIVIDUAL_INVESTORS_BANK_ACCOUNT_DETAILS_CHECKBOX',
	MIP_CREATE_PERSONAL_DATA_INDIVIDUAL_INVESTORS_TAX_RESIDENCY_CHECKBOX = 'MIP_CREATE_PERSONAL_DATA_INDIVIDUAL_INVESTORS_TAX_RESIDENCY_CHECKBOX',
	MIP_CREATE_PERSONAL_DATA_INDIVIDUAL_INVESTORS_TIN_CHECKBOX = 'MIP_CREATE_PERSONAL_DATA_INDIVIDUAL_INVESTORS_TIN_CHECKBOX',
	MIP_CREATE_PERSONAL_DATA_INDIVIDUAL_INVESTORS_PLACE_BIRTH_CHECKBOX = 'MIP_CREATE_PERSONAL_DATA_INDIVIDUAL_INVESTORS_PLACE_BIRTH_CHECKBOX',
	MIP_CREATE_PERSONAL_DATA_INDIVIDUAL_INVESTORS_COUNTRY_BIRTH_CHECKBOX = 'MIP_CREATE_PERSONAL_DATA_INDIVIDUAL_INVESTORS_COUNTRY_BIRTH_CHECKBOX',
	MIP_CREATE_PERSONAL_DATA_INDIVIDUAL_INVESTORS_EMPLOYEE_ID_CHECKBOX = 'MIP_CREATE_PERSONAL_DATA_INDIVIDUAL_INVESTORS_EMPLOYEE_ID_CHECKBOX',
	MIP_CREATE_PERSONAL_DATA_INDIVIDUAL_INVESTORS_CITIZENSHIP_CHECKBOX = 'MIP_CREATE_PERSONAL_DATA_INDIVIDUAL_INVESTORS_CITIZENSHIP_CHECKBOX',
	MIP_CREATE_PERSONAL_DATA_DELETE_CUSTOM_INDIVIDUAL_INVESTOR_DATA_BUTTON = 'MIP_CREATE_PERSONAL_DATA_DELETE_CUSTOM_INDIVIDUAL_INVESTOR_DATA_BUTTON',
	MIP_CREATE_PERSONAL_DATA_ADD_CUSTOM_INDIVIDUAL_INVESTOR_DATA_BUTTON = 'MIP_CREATE_PERSONAL_DATA_ADD_CUSTOM_INDIVIDUAL_INVESTOR_DATA_BUTTON',
	MIP_CREATE_PERSONAL_DATA_PIV_BANK_ACCOUNT_DETAILS_CHECKBOX = 'MIP_CREATE_PERSONAL_DATA_PIV_BANK_ACCOUNT_DETAILS_CHECKBOX',
	MIP_CREATE_PERSONAL_DATA_PIV_CONTROLLING_PARTY_CHECKBOX = 'MIP_CREATE_PERSONAL_DATA_PIV_CONTROLLING_PARTY_CHECKBOX',
	MIP_CREATE_PERSONAL_DATA_DELETE_CUSTOM_PIV_DATA_BUTTON = 'MIP_CREATE_PERSONAL_DATA_DELETE_CUSTOM_PIV_DATA_BUTTON',
	MIP_CREATE_PERSONAL_DATA_ADD_CUSTOM_PIV_DATA_BUTTON = 'MIP_CREATE_PERSONAL_DATA_ADD_CUSTOM_PIV_DATA_BUTTON',
	MIP_CREATE_KYC_FORM_NAME_INPUT = 'MIP_CREATE_KYC_FORM_NAME_INPUT',
	MIP_CREATE_KYC_DOCUMENT_CARD = 'MIP_CREATE_KYC_DOCUMENT_CARD',
	MIP_CREATE_KYC_DOCUMENT_CARD_MENU = 'MIP_CREATE_KYC_DOCUMENT_CARD_MENU',
	MIP_CREATE_KYC_DOCUMENT_CARD_EDIT = 'MIP_CREATE_KYC_DOCUMENT_CARD_EDIT',
	MIP_CREATE_KYC_FORM_INSTRUCTION_INPUT = 'MIP_CREATE_KYC_FORM_INSTRUCTION_INPUT',
	MIP_CREATE_KYC_DRAWER_FIELD_BINDINGS_BUTTON = 'MIP_CREATE_KYC_DRAWER_FIELD_BINDINGS_BUTTON',
	MIP_CREATE_KYC_DRAWER_SAVE_BUTTON = 'MIP_CREATE_KYC_DRAWER_SAVE_BUTTON',
	MIP_CREATE_KYC_DRAWER_CANCEL_BUTTON = 'MIP_CREATE_KYC_DRAWER_CANCEL_BUTTON',
	MIP_CREATE_KYC_FORM_ADD_INSTRUCTION = 'MIP_CREATE_KYC_FORM_ADD_INSTRUCTION',
	MIP_CREATE_KYC_FORM_DELETE_BUTTON = 'MIP_CREATE_KYC_FORM_DELETE_BUTTON',
	MIP_CREATE_KYC_INDIVIDUAL_FILE_INPUT = 'MIP_CREATE_KYC_INDIVIDUAL_FILE_INPUT',
	MIP_CREATE_KYC_PIV_FILE_INPUT = 'MIP_CREATE_KYC_PIV_FILE_INPUT',
	MIP_CREATE_KYC_CERTIFY_IDENTITY_SWITCH = 'MIP_CREATE_KYC_CERTIFY_IDENTITY_SWITCH',
	MIP_CREATE_KYC_CERTIFY_ADDRESS_SWITCH = 'MIP_CREATE_KYC_CERTIFY_ADDRESS_SWITCH',
	MIP_CREATE_KYC_CERTIFY_VEHICLE_SWITCH = 'MIP_CREATE_KYC_CERTIFY_VEHICLE_SWITCH',
	MIP_CREATE_CONTRACTS_EXPANDABLE = 'MIP_CREATE_CONTRACTS_EXPANDABLE',
	MIP_CREATE_CONTRACTS_SHOW_CONTRACT = 'MIP_CREATE_CONTRACTS_SHOW_CONTRACT',
	MIP_CREATE_CONTRACTS_CONTRACT_NAME_INPUT = 'MIP_CREATE_CONTRACTS_CONTRACT_NAME_INPUT',
	MIP_CREATE_CONTRACTS_INVESTOR_SIGNATURE_SELECT = 'MIP_CREATE_CONTRACTS_INVESTOR_SIGNATURE_SELECT',
	MIP_CREATE_CONTRACTS_CONTRACT_TYPE_SELECT = 'MIP_CREATE_CONTRACTS_CONTRACT_TYPE_SELECT',
	MIP_CREATE_CONTRACTS_EDIT_COUNTERPARTY_BUTTON = 'MIP_CREATE_CONTRACTS_EDIT_COUNTERPARTY_BUTTON',
	MIP_CREATE_CONTRACTS_ADD_COUNTERPARTY_BUTTON = 'MIP_CREATE_CONTRACTS_ADD_COUNTERPARTY_BUTTON',
	MIP_CREATE_CONTRACTS_EDIT_INSTRUCTION_BUTTON = 'MIP_CREATE_CONTRACTS_EDIT_INSTRUCTION_BUTTON',
	MIP_CREATE_CONTRACTS_ADD_INSTRUCTION_BUTTON = 'MIP_CREATE_CONTRACTS_ADD_INSTRUCTION_BUTTON',
	MIP_CREATE_CONTRACTS_INSTRUCTIONS_TO_INVESTORS_INPUT = 'MIP_CREATE_CONTRACTS_INSTRUCTIONS_TO_INVESTORS_INPUT',
	MIP_CREATE_CONTRACTS_INSTRUCTIONS_TO_INVESTORS_SAVE_BUTTON = 'MIP_CREATE_CONTRACTS_INSTRUCTIONS_TO_INVESTORS_SAVE_BUTTON',
	MIP_CREATE_CONTRACTS_INSTRUCTIONS_TO_INVESTORS_CANCEL_BUTTON = 'MIP_CREATE_CONTRACTS_INSTRUCTIONS_TO_INVESTORS_CANCEL_BUTTON',
	MIP_CREATE_CONTRACTS_DELETE_CONTRACT_BUTTON = 'MIP_CREATE_CONTRACTS_DELETE_CONTRACT_BUTTON',
	MIP_CREATE_CONTRACT_COMPONENT_COUNTERPARTIES_MODAL = 'MIP_CREATE_CONTRACT_COMPONENT_COUNTERPARTIES_MODAL',
	MIP_CREATE_SCHEDULE_PREVIEW_INDIVIDUALS_TAB = 'MIP_CREATE_SCHEDULE_PREVIEW_INDIVIDUALS_TAB',
	MIP_CREATE_SCHEDULE_PREVIEW_PIV_TAB = 'MIP_CREATE_SCHEDULE_PREVIEW_PIV_TAB',
	MIP_CREATE_INVESTORS_UPLOADED_ENTRY = 'MIP_CREATE_INVESTORS_UPLOADED_ENTRY',
	MIP_CREATE_INVESTORS_SELECT_ALL_CONTRACTS = 'MIP_CREATE_INVESTORS_SELECT_ALL_CONTRACTS',
	MIP_CREATE_INVESTORS_SELECT_CONTRACT = 'MIP_CREATE_INVESTORS_SELECT_CONTRACT',
	MIP_CREATE_INVESTORS_SUMMARY = 'MIP_CREATE_INVESTORS_SUMMARY',
	MIP_CREATE_COLLABORATE_NAME_INPUT = 'MIP_CREATE_COLLABORATE_NAME_INPUT',
	MIP_CREATE_COLLABORATE_MAIL_INPUT = 'MIP_CREATE_COLLABORATE_MAIL_INPUT',
	MIP_CREATE_COLLABORATE_COLLABORATOR_ROW = 'MIP_CREATE_COLLABORATE_COLABORATOR_ROW',
	MIP_CREATE_COLLABORATE_IS_INVESTOR_CONTACT = 'MIP_CREATE_COLLABORATE_IS_INVESTOR_CONTACT',
	MIP_CONTACT_PERSON_SWITCH = 'MIP_CONTACT_PERSON_SWITCH',
	USER_DETAIL_REMOVE_BUTTON = 'USER_DETAIL_REMOVE_BUTTON',
	MIP_CREATE_COLLABORATE_SAVE_ROW_BUTTON = 'MIP_CREATE_COLLABORATE_SAVE_ROW_BUTTON',
	MIP_CREATE_COLLABORATE_CLOSE_ROW_BUTTON = 'MIP_CREATE_COLLABORATE_CLOSE_ROW_BUTTON',
	MIP_CREATE_COLLABORATE_DELETE_ROW_BUTTON = 'MIP_CREATE_COLLABORATE_DELETE_ROW_BUTTON',
	MIP_CREATE_COLLABORATE_THREE_DOT_MENU = 'MIP_CREATE_COLLABORATE_THREE_DOT_MENU',
	MIP_CREATE_COLLABORATE_ADD_NEW_COLLABORATOR_BUTTON = 'MIP_CREATE_COLLABORATE_ADD_NEW_COLLABORATOR_BUTTON',
	MIP_CREATE_DEAL_SUMMARY_COMPLETE_SETUP_BUTTON = 'MIP_CREATE_DEAL_SUMMARY_COMPLETE_SETUP_BUTTON',
	MIP_CREATE_DEAL_SUMMARY_SAVE_DRAFT_BUTTON = 'MIP_CREATE_DEAL_SUMMARY_SAVE_DRAFT_BUTTON',
	MODAL_PROGRESS_TEXT = 'MODAL_PROGRESS_TEXT',
	MODAL_CLOSE_BUTTON = 'MODAL_CLOSE_BUTTON',
	SESSION_TIMEOUT_WARNING_MODAL = 'SESSION_TIMEOUT_WARNING_MODAL',
	SESSION_TIMEOUT_STAY_SIGNED_IN_BUTTON = 'SESSION_TIMEOUT_STAY_SIGNED_IN_BUTTON',
	SESSION_TIMEOUT_SIGN_OUT_BUTTON = 'SESSION_TIMEOUT_SIGN_OUT_BUTTON',
	GROUP_WRAPPER_ERROR_TEXT = 'GROUP_WRAPPER_ERROR_TEXT',
	DEFAULT_TOAST_TITLE = 'DEFAULT_TOAST_TITLE',
	DEFAULT_TOAST_MESSAGE = 'DEFAULT_TOAST_MESSAGE',
	ADD_SECURITY_BUTTON = 'ADD_SECURITY_BUTTON',
	SECURITIES_SAVE_BUTTON = 'SECURITIES_SAVE_BUTTON',
	SECURITIES_CLOSE_BUTTON = 'SECURITIES_CLOSE_BUTTON',
	SECURITIES_DELETE_BUTTON = 'SECURITIES_DELETE_BUTTON',
	TYPE_OF_SECURITY = 'TYPE_OF_SECURITY',
	CURRENCY_OF_SECURITY = 'CURRENCY_OF_SECURITY',
	NAME_OF_SECURITY = 'NAME_OF_SECURITY',
	VOTES_PER_SHARE_OF_SECURITY = 'VOTES_PER_SHARE_OF_SECURITY',
	NOMINAL_VALUE_OF_SECURITY = 'NOMINAL_VALUE_OF_SECURITY',
	SUBJECT_TO_VESTING_TOGGLE = 'SUBJECT_TO_VESTING_TOGGLE',
	DRAG_AND_DROP_TEMPLATE_DOWNLOAD_BUTTON = 'DRAG_AND_DROP_TEMPLATE_DOWNLOAD_BUTTON',
	DRAG_AND_DROP_UPLOAD_FILE_BUTTON = 'DRAG_AND_DROP_UPLOAD_FILE_BUTTON',
	SIDEBAR_TAB = 'SIDEBAR_TAB',
	MIP_SIDEBAR_STEP_GENERAL = 'MIP_SIDEBAR_STEP_GENERAL',
	MIP_SIDEBAR_STEP_PERSONAL = 'MIP_SIDEBAR_STEP_PERSONAL',
	MIP_SIDEBAR_STEP_KYC = 'MIP_SIDEBAR_STEP_KYC',
	MIP_SIDEBAR_STEP_SECURITIES = 'MIP_SIDEBAR_STEP_SECURITIES',
	MIP_SIDEBAR_STEP_CONTRACTS = 'MIP_SIDEBAR_STEP_CONTRACTS',
	MIP_SIDEBAR_STEP_SCHEDULE = 'MIP_SIDEBAR_STEP_SCHEDULE',
	MIP_SIDEBAR_STEP_INVESTORS = 'MIP_SIDEBAR_STEP_INVESTORS',
	MIP_SIDEBAR_STEP_COLLABORATE = 'MIP_SIDEBAR_STEP_COLLABORATE',
	MIP_SIDEBAR_STEP_SUMMARY = 'MIP_SIDEBAR_STEP_SUMMARY',
	SUB_LIST_TAB = 'SUB_LIST_TAB',
	ADD_CUSTOM_DATA_MODAL_ADD_NEW_DETAIL_BUTTON = 'ADD_CUSTOM_DATA_MODAL_ADD_NEW_DETAIL_BUTTON',
	ADD_CUSTOM_DATA_MODAL_CANCEL_BUTTON = 'ADD_CUSTOM_DATA_MODAL_CANCEL_BUTTON',
	ADD_CUSTOM_DATA_MODAL_SAVE_BUTTON = 'ADD_CUSTOM_DATA_MODAL_SAVE_BUTTON',
	ADD_CUSTOM_DATA_MODAL_NAME_INPUT = 'ADD_CUSTOM_DATA_MODAL_NAME_INPUT',
	ADD_CUSTOM_DATA_MODAL_INSTRUCTIONS_INPUT = 'ADD_CUSTOM_DATA_MODAL_INSTRUCTIONS_INPUT',
	ADD_CUSTOM_DATA_MODAL_SAVE_ROW_BUTTON = 'ADD_CUSTOM_DATA_MODAL_SAVE_ROW_BUTTON',
	ADD_CUSTOM_DATA_MODAL_CLOSE_ROW_BUTTON = 'ADD_CUSTOM_DATA_MODAL_CLOSE_ROW_BUTTON',
	ADD_CUSTOM_DATA_MODAL_DELETE_ROW_BUTTON = 'ADD_CUSTOM_DATA_MODAL_DELETE_ROW_BUTTON',
	ADD_CUSTOM_DATA_MODAL_THREE_DOT_MENU_BUTTON = 'ADD_CUSTOM_DATA_MODAL_THREE_DOT_MENU_BUTTON',
	MIP_MANAGE_INVESTORS_TAB = 'MIP_MANAGE_INVESTORS_TAB',
	MIP_MANAGE_INVESTMENTS_TAB = 'MIP_MANAGE_INVESTMENTS_TAB',
	MIP_MANAGE_DOCUMENTS_TAB = 'MIP_MANAGE_DOCUMENTS_TAB',
	MIP_MANAGE_KYC_TAB = 'MIP_MANAGE_KYC_TAB',
	MIP_MANAGE_PAYMENTS_TAB = 'MIP_MANAGE_PAYMENTS_TAB',
	MIP_MANAGE_BANK_ACCOUNTS_TAB = 'MIP_MANAGE_BANK_ACCOUNTS_TAB',
	MIP_MANAGE_BANK_ACCOUNT_APPROVE_BUTTON = 'MIP_MANAGE_BANK_ACCOUNT_APPROVE_BUTTON',
	MIP_MANAGE_BANK_ACCOUNT_DECLINE_BUTTON = 'MIP_MANAGE_BANK_ACCOUNT_DECLINE_BUTTON',
	MIP_MANAGE_BANK_ACCOUNT_REVOKE_BUTTON = 'MIP_MANAGE_BANK_ACCOUNT_REVOKE_BUTTON',
	MIP_MANAGE_BANK_ACCOUNT_DECLINE_REASON_INPUT = 'MIP_MANAGE_BANK_ACCOUNT_DECLINE_REASON_INPUT',
	MIP_MANAGE_BANK_ACCOUNT_DECLINE_CONFIRM_BUTTON = 'MIP_MANAGE_BANK_ACCOUNT_DECLINE_CONFIRM_BUTTON',
	MIP_MANAGE_BANK_ACCOUNT_DECISION_REASON = 'MIP_MANAGE_BANK_ACCOUNT_DECISION_REASON',
	MIP_MANAGE_BANK_ACCOUNT_DECISION_CARD = 'MIP_MANAGE_BANK_ACCOUNT_DECISION_CARD',
	MIP_MANAGE_INVESTMENT_BANK_TILE = 'MIP_MANAGE_INVESTMENT_BANK_TILE',
	MIP_MANAGE_BANK_ACCOUNT_ROW = 'MIP_MANAGE_BANK_ACCOUNT_ROW',
	MIP_MANAGE_BANK_ACCOUNT_REVIEW_TAB = 'MIP_MANAGE_BANK_ACCOUNT_REVIEW_TAB',
	MIP_MANAGE_BANK_ACCOUNT_HISTORY_TAB = 'MIP_MANAGE_BANK_ACCOUNT_HISTORY_TAB',
	MIP_MANAGE_BANK_ACCOUNT_RISK_BADGE = 'MIP_MANAGE_BANK_ACCOUNT_RISK_BADGE',
	MIP_MANAGE_BANK_ACCOUNT_RISK_CALLOUT = 'MIP_MANAGE_BANK_ACCOUNT_RISK_CALLOUT',
	MIP_MANAGE_BANK_ACCOUNT_DATA_GAP_ICON = 'MIP_MANAGE_BANK_ACCOUNT_DATA_GAP_ICON',
	MIP_MANAGE_BANK_ACCOUNT_DATA_GAP_CALLOUT = 'MIP_MANAGE_BANK_ACCOUNT_DATA_GAP_CALLOUT',
	MIP_MANAGE_BANK_ACCOUNT_PARTICIPANT_CARD = 'MIP_MANAGE_BANK_ACCOUNT_PARTICIPANT_CARD',
	MIP_MANAGE_BANK_ACCOUNT_VALIDATION_BADGE = 'MIP_MANAGE_BANK_ACCOUNT_VALIDATION_BADGE',
	MIP_MANAGE_BANK_ACCOUNT_ACTIONS_PANEL = 'MIP_MANAGE_BANK_ACCOUNT_ACTIONS_PANEL',
	MIP_MANAGE_BANK_ACCOUNT_EDIT_BUTTON = 'MIP_MANAGE_BANK_ACCOUNT_EDIT_BUTTON',
	MIP_MANAGE_BANK_ACCOUNT_EVENT_DIFF = 'MIP_MANAGE_BANK_ACCOUNT_EVENT_DIFF',
	MISSING = 'MISSING',
	MIP_MANAGE_PROJECT_SETTINGS_BUTTON = 'MIP_MANAGE_PROJECT_SETTINGS_BUTTON',
	MIP_MANAGE_PROJECT_SETTINGS_ENTITY_NAME_INPUT = 'MIP_MANAGE_PROJECT_SETTINGS_ENTITY_NAME_INPUT',
	MIP_MANAGE_PROJECT_SETTINGS_PROGRAMME_NAME_INPUT = 'MIP_MANAGE_PROJECT_SETTINGS_PROGRAMME_NAME_INPUT',
	MIP_MANAGE_PROJECT_SETTINGS_ADD_ANOTHER_BUTTON = 'MIP_MANAGE_PROJECT_SETTINGS_ADD_ANOTHER_BUTTON',
	MIP_MANAGE_PROJECT_SETTINGS_SAVE_BUTTON = 'MIP_MANAGE_PROJECT_SETTINGS_SAVE_BUTTON',
	PROGRAMME_UPDATE_SETTINGS_BUTTON = 'PROGRAMME_UPDATE_SETTINGS_BUTTON',
	PROGRAMME_BANK_ACCOUNT_ADD_BUTTON = 'PROGRAMME_BANK_ACCOUNT_ADD_BUTTON',
	PROFILE_BANK_ACCOUNT_TILE = 'PROFILE_BANK_ACCOUNT_TILE',
	PROFILE_BANK_ACCOUNT_ADD_BUTTON = 'PROFILE_BANK_ACCOUNT_ADD_BUTTON',
	INVESTOR_FLOW_BANK_ACCOUNT_TILE = 'INVESTOR_FLOW_BANK_ACCOUNT_TILE',
	PROGRAMME_BANK_ACCOUNT_TILE = 'PROGRAMME_BANK_ACCOUNT_TILE',
	PROGRAMME_BANK_ACCOUNT_DRAWER_HEADING = 'PROGRAMME_BANK_ACCOUNT_DRAWER_HEADING',
	PROGRAMME_BANK_ACCOUNT_INSTRUCTIONS_INPUT = 'PROGRAMME_BANK_ACCOUNT_INSTRUCTIONS_INPUT',
	MIP_MANAGE_PROJECT_SETTINGS_CANCEL_BUTTON = 'MIP_MANAGE_PROJECT_SETTINGS_CANCEL_BUTTON',
	MIP_MANAGE_PROJECT_SETTINGS_COLLABORATE_FIRST_NAME_INPUT = 'MIP_MANAGE_PROJECT_SETTINGS_COLLABORATE_FIRST_NAME_INPUT',
	MIP_MANAGE_PROJECT_SETTINGS_COLLABORATE_LAST_NAME_INPUT = 'MIP_MANAGE_PROJECT_SETTINGS_COLLABORATE_LAST_NAME_INPUT',
	MIP_MANAGE_PROJECT_SETTINGS_COLLABORATE_MAIL_INPUT = 'MIP_MANAGE_PROJECT_SETTINGS_COLLABORATE_MAIL_INPUT',
	MIP_MANAGE_PROJECT_SETTINGS_COLLABORATE_COLABORATOR_ROLE = 'MIP_MANAGE_PROJECT_SETTINGS_COLLABORATE_COLABORATOR_ROLE',
	MIP_MANAGE_PROJECT_SETTINGS_COLLABORATE_IS_INVESTOR_CONTACT = 'MIP_MANAGE_PROJECT_SETTINGS_COLLABORATE_IS_INVESTOR_CONTACT',
	MIP_MANAGE_PROJECT_SETTINGS_COLLABORATE_SAVE_ROW_BUTTON = 'MIP_MANAGE_PROJECT_SETTINGS_COLLABORATE_SAVE_ROW_BUTTON',
	MIP_MANAGE_PROJECT_SETTINGS_COLLABORATE_CLOSE_ROW_BUTTON = 'MIP_MANAGE_PROJECT_SETTINGS_COLLABORATE_CLOSE_ROW_BUTTON',
	MIP_MANAGE_PROJECT_SETTINGS_COLLABORATE_DELETE_ROW_BUTTON = 'MIP_MANAGE_PROJECT_SETTINGS_COLLABORATE_DELETE_ROW_BUTTON',
	MIP_MANAGE_PROJECT_SETTINGS_COLLABORATE_THREE_DOT_MENU = 'MIP_MANAGE_PROJECT_SETTINGS_COLLABORATE_THREE_DOT_MENU',
	MIP_MANAGE_PROJECT_SETTINGS_TABS = 'MIP_MANAGE_PROJECT_SETTINGS_TABS',
	TABLE_CHECKBOX = 'TABLE_CHECKBOX',
	CHECKBOX = 'CHECKBOX',
	MODAL_CONTINUE_BUTTON = 'MODAL_CONTINUE_BUTTON',
	MIP_MANAGE_INVESTORS_TABLE_HEADER_CHECKBOX = 'MIP_MANAGE_INVESTORS_TABLE_HEADER_CHECKBOX',
	MIP_MANAGE_INVESTORS_TABLE_BULK_ACTION_INVITATION = 'MIP_MANAGE_INVESTORS_TABLE_BULK_ACTION_INVITATION',
	MIP_MANAGE_INVESTORS_TABLE_BULK_INVITE_PROGRESS = 'MIP_MANAGE_INVESTORS_TABLE_BULK_INVITE_PROGRESS',
	MIP_MANAGE_INVESTORS_TABLE_BULK_INVITE_CLOSE_BUTTON = 'MIP_MANAGE_INVESTORS_TABLE_BULK_INVITE_CLOSE_BUTTON',
	MIP_MANAGE_INVESTORS_TABLE_BULK_ACTION_SEND_DOCUMENT = 'MIP_MANAGE_INVESTORS_TABLE_BULK_ACTION_SEND_DOCUMENT',
	MIP_MANAGE_INVESTORS_TABLE_ACTION_BUTTON = 'MIP_MANAGE_INVESTORS_TABLE_ACTION_BUTTON',
	MIP_MANAGE_INVESTORS_ROW_ACTION_SEND_INVITE = 'MIP_MANAGE_INVESTORS_ROW_ACTION_SEND_INVITE',
	MIP_MANAGE_INVESTORS_ROW_ACTION_ADD_ALLOCATION = 'MIP_MANAGE_INVESTORS_ROW_ACTION_ADD_ALLOCATION',
	MIP_MANAGE_INVESTORS_ROW_ACTION_LEAVER = 'MIP_MANAGE_INVESTORS_ROW_ACTION_LEAVER',
	MIP_MANAGE_INVESTORS_ROW_ACTION_ELIGIBILITY_NOTICE = 'MIP_MANAGE_INVESTORS_ROW_ACTION_ELIGIBILITY_NOTICE',
	MIP_MANAGE_SEND_INVITATION_MODAL_OK = 'MIP_MANAGE_SEND_INVITATION_MODAL_OK',
	MIP_MANAGE_SEND_INVITATION_MODAL_MESSAGE_TEXT_AREA = 'MIP_MANAGE_SEND_INVITATION_MODAL_MESSAGE_TEXT_AREA',
	MIP_MANAGE_SEND_INVITATION_MODAL_CANCEL = 'MIP_MANAGE_SEND_INVITATION_MODAL_CANCEL',
	MIP_MANAGE_SEND_INVITATION_MODAL_CONFIRM = 'MIP_MANAGE_SEND_INVITATION_MODAL_CONFIRM',
	MIP_MANAGE_SEND_INVITATION_MODAL_UNDO = 'MIP_MANAGE_SEND_INVITATION_MODAL_UNDO',
	MIP_MANAGE_INVESTORS_TABLE_INVESTMENTS_STATUS = 'MIP_MANAGE_INVESTORS_TABLE_INVESTMENTS_STATUS',
	MIP_MANAGE_INVESTORS_TABLE_INVESTOR_EMAIL = 'MIP_MANAGE_INVESTORS_TABLE_INVESTOR_EMAIL',
	MIP_MANAGE_INVESTORS_TABLE_OLD_INVESTOR_DETAILS_LINK = 'MIP_MANAGE_INVESTORS_TABLE_OLD_INVESTOR_DETAILS_LINK',
	MIP_MANAGE_INVESTORS_TABLE_INVESTMENT_VEHICLE_LINK = 'MIP_MANAGE_INVESTORS_TABLE_INVESTMENT_VEHICLE_LINK',
	MIP_MANAGE_INVESTMENT_VEHICLE_DETAILS_NAME = 'MIP_MANAGE_INVESTMENT_VEHICLE_DETAILS_NAME',
	MIP_MANAGE_INVESTMENT_VEHICLE_DETAILS_PIV_BADGE = 'MIP_MANAGE_INVESTMENT_VEHICLE_DETAILS_PIV_BADGE',
	MIP_MANAGE_INVESTMENT_VEHICLES_BREADCRUMB = 'MIP_MANAGE_INVESTMENT_VEHICLES_BREADCRUMB',
	MIP_MANAGE_INVESTMENT_VEHICLE_DETAILS_PROFILE_CARD = 'MIP_MANAGE_INVESTMENT_VEHICLE_DETAILS_PROFILE_CARD',
	MIP_MANAGE_INVESTMENT_VEHICLE_DETAILS_REGISTERED_NAME = 'MIP_MANAGE_INVESTMENT_VEHICLE_DETAILS_REGISTERED_NAME',
	MIP_MANAGE_INVESTMENT_VEHICLE_DETAILS_REGISTRATION_NUMBER = 'MIP_MANAGE_INVESTMENT_VEHICLE_DETAILS_REGISTRATION_NUMBER',
	MIP_MANAGE_INVESTMENT_VEHICLE_DETAILS_JURISDICTION = 'MIP_MANAGE_INVESTMENT_VEHICLE_DETAILS_JURISDICTION',
	MIP_MANAGE_INVESTMENT_VEHICLE_DETAILS_LEGAL_FORM = 'MIP_MANAGE_INVESTMENT_VEHICLE_DETAILS_LEGAL_FORM',
	MIP_MANAGE_INVESTMENT_VEHICLE_DETAILS_RELATED_PEOPLE_CARD = 'MIP_MANAGE_INVESTMENT_VEHICLE_DETAILS_RELATED_PEOPLE_CARD',
	MIP_MANAGE_INVESTMENT_VEHICLE_DETAILS_RELATED_PERSON = 'MIP_MANAGE_INVESTMENT_VEHICLE_DETAILS_RELATED_PERSON',
	MIP_MANAGE_INVESTORS_TABLE_INVESTORS_ROW = 'MIP_MANAGE_INVESTORS_TABLE_INVESTORS_ROW',
	MIP_MANAGE_INVESTORS_DETAILS_VIEW_MESSAGES_BUTTON = 'MIP_MANAGE_INVESTORS_DETAILS_VIEW_MESSAGES_BUTTON',
	MIP_MANAGE_INVESTORS_DETAILS_INVESTMENT_STATUS = 'MIP_MANAGE_INVESTORS_DETAILS_INVESTMENT_STATUS',
	MIP_MANAGE_INVESTORS_DETAILS_INVITATION_STATUS = 'MIP_MANAGE_INVESTORS_DETAILS_INVITATION_STATUS',
	MIP_MANAGE_INVESTORS_DETAILS_TOTAL_INVESTMENT = 'MIP_MANAGE_INVESTORS_DETAILS_TOTAL_INVESTMENT',
	MIP_MANAGE_INVESTORS_DETAILS_INVITATION_BUTTON = 'MIP_MANAGE_INVESTORS_DETAILS_INVITATION_BUTTON',
	MIP_MANAGE_INVESTORS_DETAILS_DASHCARD_KYC_REVIEW_BUTTON = 'MIP_MANAGE_INVESTORS_DETAILS_DASKHCARD_KYC_REVIEW_BUTTON',
	MIP_MANAGE_INVESTORS_DETAILS_HOLDING_TABLE = 'MIP_MANAGE_INVESTORS_DETAILS_HOLDING_TABLE',
	MIP_MANAGE_INVESTORS_DETAILS_HOLDING_TABLE_VESTING_ICON = 'MIP_MANAGE_INVESTORS_DETAILS_HOLDING_TABLE_VESTING_ICON',
	MIP_MANAGE_INVESTORS_DETAILS_INVESTMENT_TABLE = 'MIP_MANAGE_INVESTORS_DETAILS_INVESTMENT_TABLE',
	MIP_MANAGE_INVESTORS_DETAILS_INVESTMENT_EDIT_VESTING_BUTTON = 'MIP_MANAGE_INVESTORS_DETAILS_INVESTMENT_EDIT_VESTING_BUTTON',
	MIP_MANAGE_INVESTORS_DETAILS_VESTING_DRAWER = 'MIP_MANAGE_INVESTORS_DETAILS_VESTING_DRAWER',
	MIP_MANAGE_INVESTORS_DETAILS_VESTING_START_DATE_INPUT = 'MIP_MANAGE_INVESTORS_DETAILS_VESTING_START_DATE_INPUT',
	MIP_MANAGE_INVESTORS_DETAILS_DASHCARD_CONTRACT_REVIEW_BUTTON = 'MIP_MANAGE_INVESTORS_DETAILS_DASHCARD_CONTRACT_REVIEW_BUTTON',
	MIP_MANAGE_INVESTORS_DETAILS_COUNTERPARTY_ESIGN_BUTTON = 'MIP_MANAGE_INVESTORS_DETAILS_COUNTERPARTY_ESIGN_BUTTON',
	MIP_MANAGE_INVESTORS_DETAILS_DASHCARD_FUNDS_APPROVE_BUTTON = 'MIP_MANAGE_INVESTORS_DETAILS_DASHCARD_FUNDS_APPROVE_BUTTON',
	MIP_MANAGE_INVESTORS_DETAILS_DASHCARD_INVESTMENTS_RELEASE_BUTTON = 'MIP_MANAGE_INVESTORS_DETAILS_DASHCARD_INVESTMENTS_RELEASE_BUTTON',
	MIP_MANAGE_INVESTORS_DETAILS_COUNTERPARTY_SIGN_BUTTON = 'MIP_MANAGE_INVESTORS_DETAILS_COUNTERPARTY_SIGN_BUTTON',
	MIP_MANAGE_INVESTORS_DETAILS_PIV_TABLE = 'MIP_MANAGE_INVESTORS_DETAILS_PIV_TABLE',
	MIP_MANAGE_INVESTORS_DETAILS_PIV_REPRESENTATIVE_TABLE = 'MIP_MANAGE_INVESTORS_DETAILS_PIV_REPRESENTATIVE_TABLE',
	MIP_MANAGE_INVESTORS_DETAILS_NAME = 'MIP_MANAGE_INVESTORS_DETAILS_NAME',
	MIP_MANAGE_INVESTORS_DETAILS_STATUS_BADGE = 'MIP_MANAGE_INVESTORS_DETAILS_STATUS_BADGE',
	MIP_MANAGE_INVESTORS_DETAILS_EMAIL = 'MIP_MANAGE_INVESTORS_DETAILS_EMAIL',
	MIP_MANAGE_INVESTORS_DETAILS_COPY_EMAIL_BUTTON = 'MIP_MANAGE_INVESTORS_DETAILS_COPY_EMAIL_BUTTON',
	MIP_MANAGE_INVESTORS_DETAILS_COHORT_BADGE = 'MIP_MANAGE_INVESTORS_DETAILS_COHORT_BADGE',
	MIP_MANAGE_INVESTORS_DETAILS_PROFILE_CARD = 'MIP_MANAGE_INVESTORS_DETAILS_PROFILE_CARD',
	MIP_MANAGE_INVESTORS_DETAILS_CUSTOM_FIELDS_CARD = 'MIP_MANAGE_INVESTORS_DETAILS_CUSTOM_FIELDS_CARD',
	MIP_MANAGE_INVESTORS_DETAILS_CUSTOM_FIELDS_DRAWER = 'MIP_MANAGE_INVESTORS_DETAILS_CUSTOM_FIELDS_DRAWER',
	MIP_MANAGE_INVESTORS_DETAILS_CUSTOM_FIELDS_SAVE = 'MIP_MANAGE_INVESTORS_DETAILS_CUSTOM_FIELDS_SAVE',
	MIP_MANAGE_INVESTORS_DETAILS_HOLDINGS_SUMMARY_CARD = 'MIP_MANAGE_INVESTORS_DETAILS_HOLDINGS_SUMMARY_CARD',
	MIP_MANAGE_INVESTORS_DETAILS_HOLDINGS_CARD = 'MIP_MANAGE_INVESTORS_DETAILS_HOLDINGS_CARD',
	MIP_MANAGE_INVESTORS_DETAILS_HOLDING_CARD = 'MIP_MANAGE_INVESTORS_DETAILS_HOLDING_CARD',
	MIP_MANAGE_INVESTORS_DETAILS_HOLDING_VESTING_TOGGLE = 'MIP_MANAGE_INVESTORS_DETAILS_HOLDING_VESTING_TOGGLE',
	MIP_MANAGE_INVESTORS_DETAILS_HOLDING_TRANSACTIONS_LINK = 'MIP_MANAGE_INVESTORS_DETAILS_HOLDING_TRANSACTIONS_LINK',
	MIP_MANAGE_INVESTORS_DETAILS_HOLDING_TRANSACTIONS_MODAL = 'MIP_MANAGE_INVESTORS_DETAILS_HOLDING_TRANSACTIONS_MODAL',
	MIP_MANAGE_INVESTORS_DETAILS_HOLDING_TRANSACTIONS_ERROR = 'MIP_MANAGE_INVESTORS_DETAILS_HOLDING_TRANSACTIONS_ERROR',
	MIP_MANAGE_INVESTORS_DETAILS_HOLDING_TRANSACTION_VESTING_TERM_LINK = 'MIP_MANAGE_INVESTORS_DETAILS_HOLDING_TRANSACTION_VESTING_TERM_LINK',
	MIP_MANAGE_INVESTORS_DETAILS_HOLDING_TRANSACTION_VESTING_FORM = 'MIP_MANAGE_INVESTORS_DETAILS_HOLDING_TRANSACTION_VESTING_FORM',
	MIP_MANAGE_INVESTORS_DETAILS_HOLDING_TRANSACTION_VESTING_TERM_SELECT = 'MIP_MANAGE_INVESTORS_DETAILS_HOLDING_TRANSACTION_VESTING_TERM_SELECT',
	MIP_MANAGE_INVESTORS_DETAILS_HOLDING_TRANSACTION_VESTING_CANCEL = 'MIP_MANAGE_INVESTORS_DETAILS_HOLDING_TRANSACTION_VESTING_CANCEL',
	MIP_MANAGE_INVESTORS_DETAILS_HOLDING_TRANSACTION_VESTING_SAVE = 'MIP_MANAGE_INVESTORS_DETAILS_HOLDING_TRANSACTION_VESTING_SAVE',
	MIP_MANAGE_INVESTORS_DETAILS_HOLDING_TRANSACTION_VESTING_REMOVE = 'MIP_MANAGE_INVESTORS_DETAILS_HOLDING_TRANSACTION_VESTING_REMOVE',
	MIP_MANAGE_INVESTORS_DETAILS_OPEN_CAPTABLE = 'MIP_MANAGE_INVESTORS_DETAILS_OPEN_CAPTABLE',
	MIP_MANAGE_INVESTORS_DETAILS_HOLDINGS_EMPTY = 'MIP_MANAGE_INVESTORS_DETAILS_HOLDINGS_EMPTY',
	MIP_MANAGE_INVESTORS_DETAILS_HOLDINGS_ERROR = 'MIP_MANAGE_INVESTORS_DETAILS_HOLDINGS_ERROR',
	MIP_MANAGE_INVESTORS_DETAILS_LOANS_CARD = 'MIP_MANAGE_INVESTORS_DETAILS_LOANS_CARD',
	MIP_MANAGE_INVESTORS_DETAILS_LOANS_TABLE = 'MIP_MANAGE_INVESTORS_DETAILS_LOANS_TABLE',
	MIP_MANAGE_INVESTORS_DETAILS_LOANS_EMPTY = 'MIP_MANAGE_INVESTORS_DETAILS_LOANS_EMPTY',
	MIP_MANAGE_INVESTORS_DETAILS_LOANS_ERROR = 'MIP_MANAGE_INVESTORS_DETAILS_LOANS_ERROR',
	MIP_MANAGE_INVESTORS_DETAILS_LOANS_OPEN_CAPTABLE = 'MIP_MANAGE_INVESTORS_DETAILS_LOANS_OPEN_CAPTABLE',
	MIP_MANAGE_INVESTORS_DETAILS_DOCUMENTS_CARD = 'MIP_MANAGE_INVESTORS_DETAILS_DOCUMENTS_CARD',
	MIP_MANAGE_INVESTORS_DETAILS_DOCUMENTS_EMPTY = 'MIP_MANAGE_INVESTORS_DETAILS_DOCUMENTS_EMPTY',
	MIP_MANAGE_INVESTORS_DETAILS_DOCUMENTS_TABLE = 'MIP_MANAGE_INVESTORS_DETAILS_DOCUMENTS_TABLE',
	MIP_MANAGE_INVESTORS_DETAILS_DOCUMENTS_ERROR = 'MIP_MANAGE_INVESTORS_DETAILS_DOCUMENTS_ERROR',
	MIP_MANAGE_INVESTORS_DETAILS_DOCUMENT_PREVIEW = 'MIP_MANAGE_INVESTORS_DETAILS_DOCUMENT_PREVIEW',
	MIP_MANAGE_INVESTORS_DETAILS_DOCUMENT_CARD = 'MIP_MANAGE_INVESTORS_DETAILS_DOCUMENT_CARD',
	MIP_MANAGE_INVESTORS_DETAILS_DOCUMENTS_OPEN_LIBRARY = 'MIP_MANAGE_INVESTORS_DETAILS_DOCUMENTS_OPEN_LIBRARY',
	MIP_MANAGE_INVESTORS_DETAILS_QUICK_LINKS = 'MIP_MANAGE_INVESTORS_DETAILS_QUICK_LINKS',
	MIP_MANAGE_INVESTORS_DETAILS_ACTIVE_JOURNEYS_CARD = 'MIP_MANAGE_INVESTORS_DETAILS_ACTIVE_JOURNEYS_CARD',
	MIP_MANAGE_INVESTORS_DETAILS_ACTIVE_JOURNEYS_EMPTY = 'MIP_MANAGE_INVESTORS_DETAILS_ACTIVE_JOURNEYS_EMPTY',
	MIP_MANAGE_INVESTORS_DETAILS_ACTIVE_JOURNEYS_ERROR = 'MIP_MANAGE_INVESTORS_DETAILS_ACTIVE_JOURNEYS_ERROR',
	MIP_MANAGE_INVESTORS_DETAILS_ACTIVE_JOURNEY = 'MIP_MANAGE_INVESTORS_DETAILS_ACTIVE_JOURNEY',
	MIP_MANAGE_INVESTORS_DETAILS_ACTIVE_JOURNEY_TOGGLE = 'MIP_MANAGE_INVESTORS_DETAILS_ACTIVE_JOURNEY_TOGGLE',
	MIP_MANAGE_INVESTORS_DETAILS_QUICK_LINK = 'MIP_MANAGE_INVESTORS_DETAILS_QUICK_LINK',
	MIP_MANAGE_INVESTORS_DETAILS_RECENT_ACTIVITY_CARD = 'MIP_MANAGE_INVESTORS_DETAILS_RECENT_ACTIVITY_CARD',
	MIP_MANAGE_INVESTORS_DETAILS_RECENT_ACTIVITY_ENTRY = 'MIP_MANAGE_INVESTORS_DETAILS_RECENT_ACTIVITY_ENTRY',
	MIP_MANAGE_INVESTORS_DETAILS_ACCOUNT_ACTIVITY_CARD = 'MIP_MANAGE_INVESTORS_DETAILS_ACCOUNT_ACTIVITY_CARD',
	MIP_MANAGE_INVESTORS_DETAILS_ACCOUNT_ACTIVITY_MESSAGE = 'MIP_MANAGE_INVESTORS_DETAILS_ACCOUNT_ACTIVITY_MESSAGE',
	MIP_MANAGE_INVESTORS_DETAILS_ACCOUNT_ACTIVITY_ACTION = 'MIP_MANAGE_INVESTORS_DETAILS_ACCOUNT_ACTIVITY_ACTION',
	MIP_MANAGE_INVESTORS_DETAILS_ACCOUNT_ACTIVITY_SESSION = 'MIP_MANAGE_INVESTORS_DETAILS_ACCOUNT_ACTIVITY_SESSION',
	MIP_MANAGE_INVESTORS_DETAILS_ACCOUNT_ACTIVITY_LAST_ACTIVE = 'MIP_MANAGE_INVESTORS_DETAILS_ACCOUNT_ACTIVITY_LAST_ACTIVE',
	MIP_MANAGE_INVESTORS_DETAILS_TOTAL_VALUE = 'MIP_MANAGE_INVESTORS_DETAILS_TOTAL_VALUE',
	MIP_MANAGE_INVESTORS_DETAILS_TOTAL_COST = 'MIP_MANAGE_INVESTORS_DETAILS_TOTAL_COST',
	MIP_MANAGE_INVESTORS_DETAILS_TOTAL_LOAN_VALUE = 'MIP_MANAGE_INVESTORS_DETAILS_TOTAL_LOAN_VALUE',
	MIP_MANAGE_INVESTORS_DETAILS_VEHICLES_CARD = 'MIP_MANAGE_INVESTORS_DETAILS_VEHICLES_CARD',
	MIP_MANAGE_INVESTORS_DETAILS_INVESTMENT_VEHICLE = 'MIP_MANAGE_INVESTORS_DETAILS_INVESTMENT_VEHICLE',
	MIP_MANAGE_INVESTORS_DETAILS_BANK_CARD = 'MIP_MANAGE_INVESTORS_DETAILS_BANK_CARD',
	MIP_MANAGE_INVESTORS_DETAILS_BANK_ACCOUNT = 'MIP_MANAGE_INVESTORS_DETAILS_BANK_ACCOUNT',
	MIP_MANAGE_INVESTORS_DETAILS_BANK_ACCOUNT_COPY_BUTTON = 'MIP_MANAGE_INVESTORS_DETAILS_BANK_ACCOUNT_COPY_BUTTON',
	MIP_MANAGE_INVESTORS_DETAILS_TAX_CARD = 'MIP_MANAGE_INVESTORS_DETAILS_TAX_CARD',
	MIP_MANAGE_INVESTORS_DETAILS_TAX_RECORD = 'MIP_MANAGE_INVESTORS_DETAILS_TAX_RECORD',
	MIP_MANAGE_INVESTORS_DETAILS_TAX_TIN = 'MIP_MANAGE_INVESTORS_DETAILS_TAX_TIN',
	MIP_MANAGE_INVESTORS_DETAILS_ADDRESSES_CARD = 'MIP_MANAGE_INVESTORS_DETAILS_ADDRESSES_CARD',
	MIP_MANAGE_INVESTORS_DETAILS_ADDRESS = 'MIP_MANAGE_INVESTORS_DETAILS_ADDRESS',
	MIP_MANAGE_INVESTORS_DETAILS_EMPLOYMENT_CARD = 'MIP_MANAGE_INVESTORS_DETAILS_EMPLOYMENT_CARD',
	MIP_MANAGE_INVESTORS_DETAILS_EMPLOYMENT_RECORD = 'MIP_MANAGE_INVESTORS_DETAILS_EMPLOYMENT_RECORD',
	MIP_MANAGE_INVESTORS_DETAILS_EMPLOYMENT_EMPLOYEE_ID = 'MIP_MANAGE_INVESTORS_DETAILS_EMPLOYMENT_EMPLOYEE_ID',
	MIP_MANAGE_INVESTORS_DETAILS_PROFILE_FULL_NAME = 'MIP_MANAGE_INVESTORS_DETAILS_PROFILE_FULL_NAME',
	MIP_MANAGE_INVESTORS_DETAILS_PROFILE_EMAIL = 'MIP_MANAGE_INVESTORS_DETAILS_PROFILE_EMAIL',
	MIP_MANAGE_INVESTORS_DETAILS_PROFILE_PHONE_NUMBER = 'MIP_MANAGE_INVESTORS_DETAILS_PROFILE_PHONE_NUMBER',
	MIP_MANAGE_INVESTORS_DETAILS_MANAGE_COHORTS_BUTTON = 'MIP_MANAGE_INVESTORS_DETAILS_MANAGE_COHORTS_BUTTON',
	MIP_MANAGE_INVESTORS_DETAILS_PHONE_NUMBER = 'MIP_MANAGE_INVESTORS_DETAILS_PHONE_NUMBER',
	MIP_MANAGE_INVESTORS_BREADCRUMB = 'MIP_MANAGE_INVESTORS_BREADCRUMB',
	NEW_JOINERS_AND_ALLOCATIONS_COMPLETE_SETUP_BUTTON = 'NEW_JOINERS_AND_ALLOCATIONS_COMPLETE_SETUP_BUTTON',
	NEW_JOINERS_AND_ALLOCATIONS_PROOFS_UNAVAILABLE = 'NEW_JOINERS_AND_ALLOCATIONS_PROOFS_UNAVAILABLE',
	NEW_LEAVERS_COMPLETE_SETUP_BUTTON = 'NEW_LEAVERS_COMPLETE_SETUP_BUTTON',
	ACCOUNT_SETTING_CHANGE_PASSWORD_BUTTON = 'ACCOUNT_SETTING_CHANGE_PASSWORD_BUTTON',
	ACCOUNT_SETTING_CHANGE_PASSWORD_CURRENT_PASSWORD = 'ACCOUNT_SETTING_CHANGE_PASSWORD_CURRENT_PASSWORD',
	ACCOUNT_SETTING_CHANGE_PASSWORD_SUBMIT_BUTTON = 'ACCOUNT_SETTING_CHANGE_PASSWORD_SUBMIT_BUTTON',
	ACCOUNT_SETTING_CHANGE_PASSWORD_TOTP_CODE = 'ACCOUNT_SETTING_CHANGE_PASSWORD_TOTP_CODE',
	ACCOUNT_SETTING_CHANGE_EMAIL_TOTP_CODE = 'ACCOUNT_SETTING_CHANGE_EMAIL_TOTP_CODE',
	ACCOUNT_SETTING_CHANGE_EMAIL_BUTTON = 'ACCOUNT_SETTING_CHANGE_EMAIL_BUTTON',
	ACCOUNT_SETTING_CHANGE_EMAIL_NEW_EMAIL = 'ACCOUNT_SETTING_CHANGE_EMAIL_NEW_EMAIL',
	ACCOUNT_SETTING_CHANGE_EMAIL_CURRENT_PASSWORD = 'ACCOUNT_SETTING_CHANGE_EMAIL_CURRENT_PASSWORD',
	VERIFICATION_CODE = 'VERIFICATION_CODE',
	ACCOUNT_SETTING_CHANGE_EMAIL_VERIFICATION_CODE_REQUEST_BUTTON = 'ACCOUNT_SETTING_CHANGE_EMAIL_VERIFICATION_CODE_REQUEST_BUTTON',
	ACCOUNT_SETTING_CHANGE_EMAIL_RESEND_BUTTON = 'ACCOUNT_SETTING_CHANGE_EMAIL_RESEND_BUTTON',
	ACCOUNT_SETTING_CHANGE_EMAIL_VERIFY_CODE_BUTTON = 'ACCOUNT_SETTING_CHANGE_EMAIL_VERIFY_CODE_BUTTON',
	ACCOUNT_SETTING_CHANGE_EMAIL_LABEL_TEXT = 'ACCOUNT_SETTING_CHANGE_EMAIL_LABEL_TEXT',
	ACCOUNT_SETTING_CHANGE_EMAIL_CURRENT_EMAIL_TEXT = 'ACCOUNT_SETTING_CHANGE_EMAIL_CURRENT_EMAIL_TEXT',
	ACCOUNT_SETTING_2FA_HEADER_ACTION_BUTTON = 'ACCOUNT_SETTING_2FA_HEADER_ACTION_BUTTON',
	ACCOUNT_SETTING_2FA_SECRET_CODE = 'ACCOUNT_SETTING_2FA_SECRET_CODE',
	ACCOUNT_SETTING_2FA_SUBMIT_BUTTON = 'ACCOUNT_SETTING_2FA_SUBMIT_BUTTON',
	ACCOUNT_SETTING_AUTH_2FA_ACTION_BUTTON = 'ACCOUNT_SETTING_AUTH_2FA_ACTION_BUTTON',
	ACCOUNT_SETTING_2FA_TURN_OFF_BUTTON = 'ACCOUNT_SETTING_2FA_TURN_OFF_BUTTON',
	ACCOUNT_SETTING_QR_CODE_VERIFY_BTN = 'ACCOUNT_SETTING_QR_CODE_VERIFY_BTN',
	MINI_LIST_CARD_ITEM = 'MINI_LIST_CARD_ITEM',
	VALUATION_CREATE_BUTTON = 'VALUATION_CREATE_BUTTON',
	VALUATION_EDIT_TITLE_INPUT = 'VALUATION_EDIT_TITLE_INPUT',
	VALUATION_EDIT_SELECT_FORMATTING = 'VALUATION_EDIT_SELECT_FORMATTING',
	VALUATION_EDIT_DEFAULT_CURRENCY_SELECT = 'VALUATION_EDIT_DEFAULT_CURRENCY_SELECT',
	VALUATION_EDIT_DATE_INPUT = 'VALUATION_EDIT_DATE_INPUT',
	VALUATION_EDIT_TAGS_SELECT = 'VALUATION_EDIT_TAGS_SELECT',
	VALUATION_EDIT_FX_CONVERTER_BUTTON = 'VALUATION_EDIT_FX_CONVERTER_BUTTON',
	VALUATION_EDIT_EQUITY_VALUE_SWITCH = 'VALUATION_EDIT_EQUITY_VALUE_SWITCH',
	VALUATION_EDIT_RUN_NEW_VALUATION_BUTTON = 'VALUATION_EDIT_RUN_NEW_VALUATION_BUTTON',
	VALUATION_EDIT_INPUT_AMOUNT_INPUT = 'VALUATION_EDIT_INPUT_AMOUNT_INPUT',
	VALUATION_SUMMARY_GLOBAL_VIEW_TOGGLE = 'VALUATION_SUMMARY_GLOBAL_VIEW_TOGGLE',
	VALUATION_SUMMARY_BY_PERSON_TOGGLE = 'VALUATION_SUMMARY_BY_PERSON_TOGGLE',

	// Fund - Settings General
	FUND_SETTINGS_NAME_INPUT = 'FUND_SETTINGS_NAME_INPUT',
	FUND_SETTINGS_TARGET_INPUT = 'FUND_SETTINGS_TARGET_INPUT',
	FUND_SETTINGS_CURRENCY_SELECT = 'FUND_SETTINGS_CURRENCY_SELECT',
	FUND_SETTINGS_UPDATE_BUTTON = 'FUND_SETTINGS_UPDATE_BUTTON',

	// Table Row Actions
	TABLE_ROW_ACTIONS_MENU = 'TABLE_ROW_ACTIONS_MENU',
	TABLE_ROW_ACTION_VIEW = 'TABLE_ROW_ACTION_VIEW',
	TABLE_ROW_ACTION_EDIT = 'TABLE_ROW_ACTION_EDIT',

	// Organization - Sidebar
	ORG_SIDEBAR_FUNDS = 'ORG_SIDEBAR_FUNDS',

	// Organization - Funds Table
	FUND_TABLE_ROW = 'FUND_TABLE_ROW',

	// Fund - Settings Deals
	FUND_DEALS_LINK_BUTTON = 'FUND_DEALS_LINK_BUTTON',
	FUND_DEALS_TABLE = 'FUND_DEALS_TABLE',
	FUND_DEALS_UNLINK_BUTTON = 'FUND_DEALS_UNLINK_BUTTON',

	// Fund - Link Drawer
	LINK_FUND_DRAWER = 'LINK_FUND_DRAWER',
	LINK_FUND_DRAWER_DEALS_SELECT = 'LINK_FUND_DRAWER_DEALS_SELECT',
	LINK_FUND_DRAWER_SUBMIT = 'LINK_FUND_DRAWER_SUBMIT',

	// Fund - Master View
	FUND_MASTER_VIEW_TOGGLE = 'FUND_MASTER_VIEW_TOGGLE',
	FUND_MASTER_VIEW_TOGGLE_LABEL = 'FUND_MASTER_VIEW_TOGGLE_LABEL',
	CAP_TITLE_RAIL_TOGGLE = 'CAP_TITLE_RAIL_TOGGLE',

	// Fund - Person Deal Link
	FUND_PERSON_DEAL_LINK_SECTION = 'FUND_PERSON_DEAL_LINK_SECTION',
	FUND_PERSON_DEAL_LINK_TILE = 'FUND_PERSON_DEAL_LINK_TILE',
	FUND_PERSON_DEAL_LINK_DELETE = 'FUND_PERSON_DEAL_LINK_DELETE',

	// Signature success confirmation (DC-895)
	SIGNATURE_SUCCESS_CONFIRMATION = 'SIGNATURE_SUCCESS_CONFIRMATION',
	SIGNATURE_SUCCESS_DOWNLOAD_BUTTON = 'SIGNATURE_SUCCESS_DOWNLOAD_BUTTON',

	// Public signing
	PUBLIC_SIGNING_PANEL_PANE = 'PUBLIC_SIGNING_PANEL_PANE',
	PUBLIC_SIGNING_WITNESS_DETAILS_FORM = 'PUBLIC_SIGNING_WITNESS_DETAILS_FORM',
	PUBLIC_SIGNING_WITNESS_FULL_NAME = 'PUBLIC_SIGNING_WITNESS_FULL_NAME',
	PUBLIC_SIGNING_WITNESS_ADDRESS = 'PUBLIC_SIGNING_WITNESS_ADDRESS',
	PUBLIC_SIGNING_WITNESS_OCCUPATION = 'PUBLIC_SIGNING_WITNESS_OCCUPATION',
	PUBLIC_SIGNING_WITNESS_DETAILS_SUBMIT = 'PUBLIC_SIGNING_WITNESS_DETAILS_SUBMIT',
	PUBLIC_SIGNING_WITNESS_DETAILS_CANCEL = 'PUBLIC_SIGNING_WITNESS_DETAILS_CANCEL',
	PUBLIC_SIGNING_CERTIFICATION_TEXT_STEP = 'PUBLIC_SIGNING_CERTIFICATION_TEXT_STEP',
	PUBLIC_SIGNING_CERTIFICATION_TEXT_INPUT = 'PUBLIC_SIGNING_CERTIFICATION_TEXT_INPUT',
	PUBLIC_SIGNING_CERTIFICATION_TEXT_RESET = 'PUBLIC_SIGNING_CERTIFICATION_TEXT_RESET',
	PUBLIC_SIGNING_CERTIFICATION_TEXT_UPDATE = 'PUBLIC_SIGNING_CERTIFICATION_TEXT_UPDATE',
	PUBLIC_SIGNING_CERTIFICATION_CONFIRM = 'PUBLIC_SIGNING_CERTIFICATION_CONFIRM',
	PUBLIC_SIGNING_CERTIFICATION_CONTINUE = 'PUBLIC_SIGNING_CERTIFICATION_CONTINUE',

	// eID Easy in-app signing modal
	EID_EASY_METHOD_OTP_CARD = 'EID_EASY_METHOD_OTP_CARD',
	EID_EASY_METHOD_DRAW_CARD = 'EID_EASY_METHOD_DRAW_CARD',
	EID_EASY_METHOD_SMART_ID_CARD = 'EID_EASY_METHOD_SMART_ID_CARD',
	EID_EASY_METHOD_FTN_CARD = 'EID_EASY_METHOD_FTN_CARD',
	EID_EASY_METHOD_SE_BANKID_CARD = 'EID_EASY_METHOD_SE_BANKID_CARD',
	EID_EASY_METHOD_NO_BANKID_CARD = 'EID_EASY_METHOD_NO_BANKID_CARD',
	EID_EASY_METHOD_MITID_CARD = 'EID_EASY_METHOD_MITID_CARD',
	EID_EASY_METHOD_FREJA_CARD = 'EID_EASY_METHOD_FREJA_CARD',
	EID_EASY_SIGNATURE_PAD = 'EID_EASY_SIGNATURE_PAD',
	EID_EASY_SIGNATURE_CONFIRM_BUTTON = 'EID_EASY_SIGNATURE_CONFIRM_BUTTON',
	EID_EASY_OTP_EMAIL_INPUT = 'EID_EASY_OTP_EMAIL_INPUT',
	EID_EASY_OTP_USE_EMAIL_BUTTON = 'EID_EASY_OTP_USE_EMAIL_BUTTON',
	EID_EASY_OTP_SEND_CODE_BUTTON = 'EID_EASY_OTP_SEND_CODE_BUTTON',
	EID_EASY_OTP_CODE_INPUT = 'EID_EASY_OTP_CODE_INPUT',
	EID_EASY_OTP_VERIFY_BUTTON = 'EID_EASY_OTP_VERIFY_BUTTON',
	EID_EASY_SMART_ID_IDCODE_INPUT = 'EID_EASY_SMART_ID_IDCODE_INPUT',
	EID_EASY_SMART_ID_SIGN_BUTTON = 'EID_EASY_SMART_ID_SIGN_BUTTON',
	EID_EASY_FREJA_EMAIL_INPUT = 'EID_EASY_FREJA_EMAIL_INPUT',
	EID_EASY_FREJA_SIGN_BUTTON = 'EID_EASY_FREJA_SIGN_BUTTON',
	// Method-select step: the options group (any method cards shown) and the "view all" action
	// that expands a country-restricted initial view to every eligible method
	EID_EASY_METHOD_SELECT_OPTIONS = 'EID_EASY_METHOD_SELECT_OPTIONS',
	EID_EASY_METHOD_SELECT_VIEW_ALL_BUTTON = 'EID_EASY_METHOD_SELECT_VIEW_ALL_BUTTON',
	// Saved-signature picker (shown to authenticated signers with a prior signature)
	EID_EASY_SAVED_SIGNATURE_CREATE_NEW = 'EID_EASY_SAVED_SIGNATURE_CREATE_NEW',
	// Per-signer "Sign" button on the admin MIP-manage Documents → Signers tab
	DOCUMENT_SIGNER_SIGN_BUTTON = 'DOCUMENT_SIGNER_SIGN_BUTTON',
	// "Claim" button on an empty signer slot — assigns the open role to the current admin
	DOCUMENT_SIGNER_CLAIM_BUTTON = 'DOCUMENT_SIGNER_CLAIM_BUTTON',
	// "Invite authorised signatory" button on an empty counterparty slot
	DOCUMENT_SIGNER_INVITE_AUTHORISED_SIGNATORY_BUTTON = 'DOCUMENT_SIGNER_INVITE_AUTHORISED_SIGNATORY_BUTTON',
	// Per-signer 3-dot config menu trigger on the Signers tab. Suffixed with the signer's
	// role type (e.g. `${DOCUMENT_SIGNER_MENU_TRIGGER}-PARTY`) so a specific signer's menu
	// can be opened unambiguously when several roles are present on one document.
	DOCUMENT_SIGNER_MENU_TRIGGER = 'DOCUMENT_SIGNER_MENU_TRIGGER',
	// Group-header 3-dot menu trigger (assign/unassign plus the by-role witness and
	// simple-sign toggles). Absent entirely once the group has no actions left. Not unique by
	// itself — every role's group header shares this id, so scope through
	// DOCUMENT_SIGNER_GROUP_SECTION when more than one role's group renders a menu.
	DOCUMENT_SIGNER_GROUP_MENU_TRIGGER = 'DOCUMENT_SIGNER_GROUP_MENU_TRIGGER',
	// Wrapper for one role's whole signer group (header + cards + empty slots). Suffixed with
	// the role type (e.g. `${DOCUMENT_SIGNER_GROUP_SECTION}-COUNTERPARTY`) so a test can scope
	// into a specific group's header/menu when several roles' groups render on one document.
	DOCUMENT_SIGNER_GROUP_SECTION = 'DOCUMENT_SIGNER_GROUP_SECTION',
	// Per-signer config menu items: enable/disable witnessing, allow/disable simple sign,
	// and claim the signer's own slot to sign on their behalf (Power of Attorney)
	DOCUMENT_SIGNER_TOGGLE_WITNESS = 'DOCUMENT_SIGNER_TOGGLE_WITNESS',
	DOCUMENT_SIGNER_TOGGLE_SIMPLE_SIGN = 'DOCUMENT_SIGNER_TOGGLE_SIMPLE_SIGN',
	DOCUMENT_SIGNER_CLAIM_ON_BEHALF = 'DOCUMENT_SIGNER_CLAIM_ON_BEHALF',
	// Remove an outstanding, unsigned signature requirement, and its confirmation modal.
	DOCUMENT_SIGNER_REMOVE = 'DOCUMENT_SIGNER_REMOVE',
	REMOVE_SIGNER_CONFIRM_BUTTON = 'REMOVE_SIGNER_CONFIRM_BUTTON',
	REMOVE_SIGNER_CANCEL_BUTTON = 'REMOVE_SIGNER_CANCEL_BUTTON',
	// Wrapper for a signer card, so a test can scope to one card on a document that has
	// several signers in the same role.
	DOCUMENT_SIGNER_CARD = 'DOCUMENT_SIGNER_CARD',
	// Investor portal: per-contract eID Easy "Sign" button
	INVESTOR_DOCUMENT_SIGN_BUTTON = 'INVESTOR_DOCUMENT_SIGN_BUTTON',
	// Investor portal: the contracts-table "Representative Witness" column header. Rendered only
	// when a representative signer requires a witness, so its presence is the honoured-state signal.
	INVESTOR_REPRESENTATIVE_WITNESS_COLUMN = 'INVESTOR_REPRESENTATIVE_WITNESS_COLUMN',
	// Public signing page: retry for a witness invitation that failed at signing completion.
	PUBLIC_WITNESS_INVITE_RETRY_BUTTON = 'PUBLIC_WITNESS_INVITE_RETRY_BUTTON',
	// Investor portal: "Email Witness" button on the contracts table (opens the witness-invite modal)
	INVESTOR_WITNESS_INVITE_BUTTON = 'INVESTOR_WITNESS_INVITE_BUTTON',
	// Investor portal: witness-invite modal — email input + send button
	INVESTOR_WITNESS_EMAIL_INPUT = 'INVESTOR_WITNESS_EMAIL_INPUT',
	INVESTOR_WITNESS_INVITE_SUBMIT_BUTTON = 'INVESTOR_WITNESS_INVITE_SUBMIT_BUTTON',
	// Investor portal: in-modal witness-configuration step (shown before signing a
	// witness-required contract) — email field, the 3 eligibility checkboxes, and continue
	INVESTOR_WITNESS_CONFIG_EMAIL_INPUT = 'witness-email-input',
	INVESTOR_WITNESS_CONFIG_INDEPENDENT = 'witness-eligibility-independent',
	INVESTOR_WITNESS_CONFIG_AGE = 'witness-eligibility-age',
	INVESTOR_WITNESS_CONFIG_NOT_PARTY = 'witness-eligibility-not-party',
	INVESTOR_WITNESS_CONFIG_CONTINUE_BUTTON = 'witness-continue-button',
	// Investor portal: witness success step shown once a witness-required signature completes
	INVESTOR_WITNESS_SUCCESS_CONFIRMATION = 'witness-success-confirmation',
	// eID Easy signing modal close (X) button — dismisses the modal after the success step
	EID_EASY_SIGNING_MODAL_CLOSE_BUTTON = 'EID_EASY_SIGNING_MODAL_CLOSE_BUTTON',

	// DC-1000 post-dating: Master Documents edit form + placement editor
	MASTER_DOCUMENT_POST_DATING_SWITCH = 'MASTER_DOCUMENT_POST_DATING_SWITCH',
	// DC-1136: one button for one editor. There is no manual-placement switch any more — whether
	// a document uses manual placement is derived from whether the author placed anything.
	MASTER_DOCUMENT_OPEN_DOCUMENT_EDITOR_BUTTON = 'MASTER_DOCUMENT_OPEN_DOCUMENT_EDITOR_BUTTON',
	// DC-1157: wraps the button above when the editor has no job — a multi-sign document can
	// neither be personalised nor carry placed signatures.
	MASTER_DOCUMENT_DOCUMENT_EDITOR_BLOCKED_TOOLTIP = 'MASTER_DOCUMENT_DOCUMENT_EDITOR_BLOCKED_TOOLTIP',
	PLACEMENT_EDITOR_ADD_DATE_FIELD_BUTTON = 'PLACEMENT_EDITOR_ADD_DATE_FIELD_BUTTON',
	PLACEMENT_EDITOR_SAVE_BUTTON = 'PLACEMENT_EDITOR_SAVE_BUTTON',
	PLACEMENT_EDITOR_SLOT_LIST = 'PLACEMENT_EDITOR_SLOT_LIST',
	// Suffixed with the slot's own key, so one row can be addressed among many.
	PLACEMENT_EDITOR_SLOT_ROW = 'PLACEMENT_EDITOR_SLOT_ROW',
	// Shared by every drawn box — they are counted rather than addressed individually.
	PLACEMENT_EDITOR_BOX = 'PLACEMENT_EDITOR_BOX',
	PLACEMENT_EDITOR_BOX_REMOVE = 'PLACEMENT_EDITOR_BOX_REMOVE',

	// DC-1000 post-dating: signers panel "Apply date" action, details drawer readout + modal
	DOCUMENT_SIGNERS_APPLY_DATE_BUTTON = 'DOCUMENT_SIGNERS_APPLY_DATE_BUTTON',
	DOCUMENT_DETAILS_APPLIED_DATE_VALUE = 'DOCUMENT_DETAILS_APPLIED_DATE_VALUE',
	APPLY_DATE_MODAL_DATE_INPUT = 'APPLY_DATE_MODAL_DATE_INPUT',
	APPLY_DATE_MODAL_SUBMIT_BUTTON = 'APPLY_DATE_MODAL_SUBMIT_BUTTON',
	APPLY_DATE_MODAL_PROGRESS = 'APPLY_DATE_MODAL_PROGRESS',

	// DC-1145 bulk post-dating: the bulk-actions menu item, and the BulkApplyDateModal's
	// date-entry, progress and summary views
	BULK_APPLY_DATE_ACTION = 'BULK_APPLY_DATE_ACTION',
	BULK_APPLY_DATE_INPUT = 'BULK_APPLY_DATE_INPUT',
	BULK_APPLY_DATE_SUBMIT = 'BULK_APPLY_DATE_SUBMIT',
	BULK_APPLY_DATE_PROGRESS_COUNT = 'BULK_APPLY_DATE_PROGRESS_COUNT',
	BULK_APPLY_DATE_SUMMARY_COUNT = 'BULK_APPLY_DATE_SUMMARY_COUNT',
	/** On the summary only when the job ended FAILED — the count renders the same either way. */
	BULK_APPLY_DATE_SUMMARY_FAILED = 'BULK_APPLY_DATE_SUMMARY_FAILED',
	BULK_APPLY_DATE_SKIPPED_LIST = 'BULK_APPLY_DATE_SKIPPED_LIST',
	BULK_APPLY_DATE_FAILED_LIST = 'BULK_APPLY_DATE_FAILED_LIST',
	BULK_APPLY_DATE_ERRORS_LIST = 'BULK_APPLY_DATE_ERRORS_LIST',
	BULK_APPLY_DATE_STATUS_ERROR = 'BULK_APPLY_DATE_STATUS_ERROR',

	// DC-1236 bulk eID Easy signing: the bulk-actions menu item, and the signing modal's done step
	BULK_SIGN_ACTION = 'BULK_SIGN_ACTION',
	EID_EASY_SIGNING_DONE = 'EID_EASY_SIGNING_DONE',

	// DC-1000 post-dating: per-event-type testid on an Activity tab history row
	// (suffixed with the DocumentWorkflowEventLogType, e.g. `${ACTIVITY_HISTORY_EVENT}-DOCUMENT_DATE_APPLIED`)
	ACTIVITY_HISTORY_EVENT = 'ACTIVITY_HISTORY_EVENT',

	// DC-1047 add investor: signers panel action + refusal explanation, and the picker modal
	ADD_INVESTOR_ACTION_BUTTON = 'ADD_INVESTOR_ACTION_BUTTON',
	ADD_INVESTOR_REFUSAL_MESSAGE = 'ADD_INVESTOR_REFUSAL_MESSAGE',
	ADD_INVESTOR_REISSUE_LINK = 'ADD_INVESTOR_REISSUE_LINK',
	ADD_INVESTOR_MODAL = 'ADD_INVESTOR_MODAL',
	ADD_INVESTOR_MODAL_SLOTS_COUNTER = 'ADD_INVESTOR_MODAL_SLOTS_COUNTER',
	// Shared by every investor checkbox in the picker — options are told apart by their label text.
	ADD_INVESTOR_MODAL_OPTION = 'ADD_INVESTOR_MODAL_OPTION',
	ADD_INVESTOR_MODAL_SUBMIT_BUTTON = 'ADD_INVESTOR_MODAL_SUBMIT_BUTTON',

	ADD_COUNTERPARTY_ACTION_BUTTON = 'ADD_COUNTERPARTY_ACTION_BUTTON',
	ADD_COUNTERPARTY_REFUSAL_MESSAGE = 'ADD_COUNTERPARTY_REFUSAL_MESSAGE',
	ADD_COUNTERPARTY_REVOKE_LINK = 'ADD_COUNTERPARTY_REVOKE_LINK',
	ADD_COUNTERPARTY_MODAL = 'ADD_COUNTERPARTY_MODAL',
	ADD_COUNTERPARTY_MODAL_NAME_INPUT = 'ADD_COUNTERPARTY_MODAL_NAME_INPUT',
	ADD_COUNTERPARTY_MODAL_SLOT_COUNT = 'ADD_COUNTERPARTY_MODAL_SLOT_COUNT',
	ADD_COUNTERPARTY_MODAL_SLOTS_COUNTER = 'ADD_COUNTERPARTY_MODAL_SLOTS_COUNTER',
	// Shared by every slot block in the modal — slots are told apart by their heading text.
	ADD_COUNTERPARTY_MODAL_SLOT = 'ADD_COUNTERPARTY_MODAL_SLOT',
	ADD_COUNTERPARTY_MODAL_SUBMIT_BUTTON = 'ADD_COUNTERPARTY_MODAL_SUBMIT_BUTTON',
	// DC-1048: only rendered on a document that stamps by hand, where the party's boxes are
	// drawn on a second step before the add is allowed.
	ADD_COUNTERPARTY_MODAL_NEXT_BUTTON = 'ADD_COUNTERPARTY_MODAL_NEXT_BUTTON',
	ADD_COUNTERPARTY_MODAL_BACK_BUTTON = 'ADD_COUNTERPARTY_MODAL_BACK_BUTTON',
	ADD_COUNTERPARTY_PLACEMENT_STEP = 'ADD_COUNTERPARTY_PLACEMENT_STEP',

	// The documents list's "you are in X mode" banner. The mode arrives on router state rather
	// than the URL, so this banner is the only durable proof a deep-link into it landed.
	DOCUMENTS_ELIGIBLE_FILTER_MODE_BANNER = 'DOCUMENTS_ELIGIBLE_FILTER_MODE_BANNER',

	// DC-1098: close a document without the investor's signature (Details tab section + modal)
	CLOSE_DOCUMENT_REASON_INPUT = 'CLOSE_DOCUMENT_REASON_INPUT',
	CLOSE_DOCUMENT_CONFIRM_BUTTON = 'CLOSE_DOCUMENT_CONFIRM_BUTTON',

	// Cancel an invited authorised signatory (signer card menu item + confirm modal)
	DOCUMENT_SIGNER_CANCEL_AUTHORISED_SIGNATORY = 'DOCUMENT_SIGNER_CANCEL_AUTHORISED_SIGNATORY',
	CANCEL_AUTHORISED_SIGNATORY_CONFIRM_BUTTON = 'CANCEL_AUTHORISED_SIGNATORY_CONFIRM_BUTTON',

	// DC-1148: single-document "Invite Authorised Signatory" modal (email + first/last name)
	AUTHORISED_SIGNATORY_MODAL_EMAIL_INPUT = 'AUTHORISED_SIGNATORY_MODAL_EMAIL_INPUT',
	AUTHORISED_SIGNATORY_MODAL_FIRST_NAME_INPUT = 'AUTHORISED_SIGNATORY_MODAL_FIRST_NAME_INPUT',
	AUTHORISED_SIGNATORY_MODAL_LAST_NAME_INPUT = 'AUTHORISED_SIGNATORY_MODAL_LAST_NAME_INPUT',
	AUTHORISED_SIGNATORY_MODAL_SUBMIT_BUTTON = 'AUTHORISED_SIGNATORY_MODAL_SUBMIT_BUTTON',

	// DC-1148: "Assign authorised signatory" bulk-actions-menu item on the documents list
	BULK_ACTIONS_MENU_ASSIGN_AUTHORISED_SIGNATORY = 'BULK_ACTIONS_MENU_ASSIGN_AUTHORISED_SIGNATORY',

	// DC-1148: bulk assign/cancel authorised signatory modal — per-role invite inputs, the
	// per-invitee cancel toggle, confirm, and the post-submit result summary
	// On Modal.Content, not Modal.Root — Root has no box of its own.
	BULK_INVITE_AUTHORISED_SIGNATORY_MODAL = 'BULK_INVITE_AUTHORISED_SIGNATORY_MODAL',
	BULK_INVITE_AUTHORISED_SIGNATORY_EMAIL_INPUT = 'BULK_INVITE_AUTHORISED_SIGNATORY_EMAIL_INPUT',
	BULK_INVITE_AUTHORISED_SIGNATORY_FIRST_NAME_INPUT = 'BULK_INVITE_AUTHORISED_SIGNATORY_FIRST_NAME_INPUT',
	BULK_INVITE_AUTHORISED_SIGNATORY_LAST_NAME_INPUT = 'BULK_INVITE_AUTHORISED_SIGNATORY_LAST_NAME_INPUT',
	BULK_INVITE_AUTHORISED_SIGNATORY_CANCEL_TOGGLE = 'BULK_INVITE_AUTHORISED_SIGNATORY_CANCEL_TOGGLE',
	BULK_INVITE_AUTHORISED_SIGNATORY_CONFIRM_BUTTON = 'BULK_INVITE_AUTHORISED_SIGNATORY_CONFIRM_BUTTON',
	BULK_INVITE_AUTHORISED_SIGNATORY_RESULT_SUMMARY = 'BULK_INVITE_AUTHORISED_SIGNATORY_RESULT_SUMMARY',
	BULK_INVITE_AUTHORISED_SIGNATORY_RESULT_SKIPPED_DUPLICATE = 'BULK_INVITE_AUTHORISED_SIGNATORY_RESULT_SKIPPED_DUPLICATE',
	BULK_INVITE_AUTHORISED_SIGNATORY_RESULT_CLOSE_BUTTON = 'BULK_INVITE_AUTHORISED_SIGNATORY_RESULT_CLOSE_BUTTON',

	// DC-1203: group-header "Assign" menu item, and the AssignSignerForm it opens
	DOCUMENT_SIGNER_GROUP_MENU_ASSIGN = 'DOCUMENT_SIGNER_GROUP_MENU_ASSIGN',
	DOCUMENT_SIGNER_ASSIGN_FORM_SELECT = 'DOCUMENT_SIGNER_ASSIGN_FORM_SELECT',
	DOCUMENT_SIGNER_ASSIGN_FORM_CONFIRM_BUTTON = 'DOCUMENT_SIGNER_ASSIGN_FORM_CONFIRM_BUTTON',
	DOCUMENT_SIGNER_ASSIGN_FORM_CANCEL_BUTTON = 'DOCUMENT_SIGNER_ASSIGN_FORM_CANCEL_BUTTON',

	// DC-1203: "Assign counterparty" bulk-actions-menu item, and the BulkAssignCounterpartyModal
	BULK_ACTIONS_MENU_ASSIGN_COUNTERPARTY = 'BULK_ACTIONS_MENU_ASSIGN_COUNTERPARTY',
	BULK_ASSIGN_COUNTERPARTY_MODAL = 'BULK_ASSIGN_COUNTERPARTY_MODAL',
	BULK_ASSIGN_COUNTERPARTY_ROLE_SELECT = 'BULK_ASSIGN_COUNTERPARTY_ROLE_SELECT',
	BULK_ASSIGN_COUNTERPARTY_CONFIRM_BUTTON = 'BULK_ASSIGN_COUNTERPARTY_CONFIRM_BUTTON',
	BULK_ASSIGN_COUNTERPARTY_CLOSE_BUTTON = 'BULK_ASSIGN_COUNTERPARTY_CLOSE_BUTTON',
	BULK_ASSIGN_COUNTERPARTY_PROGRESS_BREAKDOWN = 'BULK_ASSIGN_COUNTERPARTY_PROGRESS_BREAKDOWN',

	// DC-1173: "Add counterparty" bulk-actions-menu item, and the BulkAddCounterpartyModal
	BULK_ACTIONS_MENU_ADD_COUNTERPARTY = 'BULK_ACTIONS_MENU_ADD_COUNTERPARTY',
	BULK_ADD_COUNTERPARTY_MODAL = 'BULK_ADD_COUNTERPARTY_MODAL',
	BULK_ADD_COUNTERPARTY_NAME_INPUT = 'BULK_ADD_COUNTERPARTY_NAME_INPUT',
	BULK_ADD_COUNTERPARTY_SLOT_COUNT_SELECT = 'BULK_ADD_COUNTERPARTY_SLOT_COUNT_SELECT',
	BULK_ADD_COUNTERPARTY_SLOT_MODE = 'BULK_ADD_COUNTERPARTY_SLOT_MODE',
	BULK_ADD_COUNTERPARTY_PREVIEW_BUTTON = 'BULK_ADD_COUNTERPARTY_PREVIEW_BUTTON',
	BULK_ADD_COUNTERPARTY_CONFIRM_BUTTON = 'BULK_ADD_COUNTERPARTY_CONFIRM_BUTTON',
	BULK_ADD_COUNTERPARTY_CLOSE_BUTTON = 'BULK_ADD_COUNTERPARTY_CLOSE_BUTTON',
	BULK_ADD_COUNTERPARTY_SKIP_TABLE = 'BULK_ADD_COUNTERPARTY_SKIP_TABLE',
}

export enum VALUATION_ELEMENT_ID {
	NEW_VALUATION_HEADER_BTN = 'NEW_VALUATION_HEADER_BTN',
	SOURCES_AND_USES = 'VALUATION_SOURCES_AND_USES',
	SOURCES_AND_USES_TITLE = 'VALUATION_SOURCES_AND_USES_TITLE',
	DISTRIBUTION_RULE_TABLE = 'DISTRIBUTION_RULE_TABLE',
	DISTRIBUTION_RULE_TABLE_DESCRIPTION_CELL = 'DISTRIBUTION_RULE_TABLE_DESCRIPTION_CELL',
	DISTRIBUTION_RULE_TABLE_INTEREST_DOWNLOAD = 'DISTRIBUTION_RULE_TABLE_INTEREST_DOWNLOAD',
	SOURCES_AND_USES_BREAKPOINT_SUMMARY_BTN = 'SOURCES_AND_USES_BREAKPOINT_SUMMARY_BTN',
	SOURCES_AND_USES_PROCEEDS_SECTION = 'SOURCES_AND_USES_PROCEEDS_SECTION',
	SOURCES_AND_USES_DISTRIBUTION_SECTION = 'SOURCES_AND_USES_DISTRIBUTION_SECTION',
	SOURCES_AND_USES_FOOTER_SECTION_TOTAL_SOURCES = 'SOURCES_AND_USES_FOOTER_SECTION_TOTAL_SOURCES',
	SOURCES_AND_USES_FOOTER_SECTION_TOTAL_USES = 'SOURCES_AND_USES_FOOTER_SECTION_TOTAL_USES',
	SOURCES_AND_USES_TABLE_CATEGORY = 'SOURCES_AND_USES_TABLE_CATEGORY',
	SOURCES_AND_USES_TABLE_CATEGORY_BTN = 'SOURCES_AND_USES_TABLE_CATEGORY_BTN',
	SOURCES_AND_USES_TABLE_SPACE = 'SOURCES_AND_USES_TABLE_SPACE',

	BREAKPOINT_TABLE_SPACE = 'BREAKPOINT_TABLE_SPACE',
	BREAKPOINT_DISTRIBUTION_RULES_BTN = 'BREAKPOINT_DISTRIBUTION_RULES_BTN',

	SOURCES_AND_USES_TABLE = 'SOURCES_AND_USES_TABLE',
	SOURCES_AND_USES_TABLE_TOTAL_ROW = 'SOURCES_AND_USES_TABLE_TOTAL_ROW',
	SOURCES_AND_USES_TABLE_TOTAL_VALUE_INPUT_AMOUNT = 'SOURCES_AND_USES_TABLE_TOTAL_VALUE_INPUT_AMOUNT',
	SOURCES_AND_USES_TABLE_TOTAL_VALUE_CONVERTED_AMOUNT = 'SOURCES_AND_USES_TABLE_TOTAL_VALUE_CONVERTED_AMOUNT',
	SOURCES_AND_USES_TABLE_NAME_CELL_INPUT = 'SOURCES_AND_USES_TABLE_NAME_CELL_INPUT',

	SUMMARY_TABLE = 'SUMMARY_TABLE',
	SUMMARY_TABLE_VALUATION_DATE = 'SUMMARY_TABLE_VALUATION_DATE',
	BREADCRUMB_VALUATION_HOME = 'BREADCRUMB_VALUATION_HOME',
	BREADCRUMB_VALUATION_EDIT = 'BREADCRUMB_VALUATION_EDIT',
	BREADCRUMB_VALUATION_SUMMARY = 'BREADCRUMB_VALUATION_SUMMARY',
	BREADCRUMB_VALUATION_SOURCES_AND_USES = 'BREADCRUMB_VALUATION_SOURCES_AND_USES',
	BREADCRUMB_VALUATION_BREAKPOINT_SUMMARY = 'BREADCRUMB_VALUATION_BREAKPOINT_SUMMARY',
	PERSON_FILTER_TABLE_BTN = 'PERSON_FILTER_TABLE_BTN',
	METRIC_LABEL = 'METRIC_LABEL',
	METRIC_BANNER = 'METRIC_BANNER',
	VALUATION_SUMMARY_TITLE = 'VALUATION_SUMMARY_TITLE',
	VALUATION_CARD = 'VALUATION_CARD',
	VALUATION_DROPDOWN_BTN = 'VALUATION_DROPDOWN_BTN',
	VALUATION_TAG_CARD = 'VALUATION_TAG_CARD',
	VALUATION_INPUT_REMOVE_TAG = 'VALUATION_INPUT_REMOVE_TAG',
	VALUATION_SUMMARY_DOWNLOAD = 'VALUATION_SUMMARY_DOWNLOAD',
	VALUATION_SUMMARY_EDIT_VALUATION_BTN = 'VALUATION_SUMMARY_EDIT_VALUATION_BTN',
	LINEAR_SOLVE_WARNING = 'VALUATION_LINEAR_SOLVE_WARNING',
	METRIC_VALUE = 'METRIC_VALUE',
	TARGET_NODE = 'TARGET_NODE',
	NODE_LIST = 'NODE_LIST',
	TOTAL_EQUITY_VALUE = 'TOTAL_EQUITY_VALUE',
	TARGET_NODE_EQUITY_VALUE = 'TARGET_NODE_EQUITY_VALUE',
	INPUT_CURRENCY = 'INPUT_CURRENCY',
	INPUT_TABLE = 'INPUT_TABLE',
	INPUT_AMOUNT = 'INPUT_AMOUNT',
	CASH_DEBT_ADJUSTMENT_BUTTON = 'CASH_DEBT_ADJUSTMENT_BUTTON',
	CASH_DEBT_ADJUSTMENT_BUTTON_DELETE = 'CASH_DEBT_ADJUSTMENT_BUTTON_DELETE',
	CASH_DEBT_ADJUSTMENT_CONVERTED_AMOUNT = 'CASH_DEBT_ADJUSTMENT_CONVERTED_AMOUNT',
	CASH_DEBT_ADJUSTMENT_ROW = 'CASH_DEBT_ADJUSTMENT_ROW',
	CASH_DEBT_ADJUSTMENT_ADJUSTMENT_LABEL = 'CASH_DEBT_ADJUSTMENT_ADJUSTMENT_LABEL',
	CASH_DEBT_ADJUSTMENT_ADJUSTMENT_TOTAL_VALUE = 'CASH_DEBT_ADJUSTMENT_ADJUSTMENT_TOTAL_VALUE',
	NET_WORKING_CAPITAL_ADJUSTMENT_BUTTON = 'NET_WORKING_CAPITAL_ADJUSTMENT_BUTTON',
	NET_WORKING_CAPITAL_ADJUSTMENT_BUTTON_DELETE = 'NET_WORKING_CAPITAL_ADJUSTMENT_BUTTON_DELETE',
	NET_WORKING_CAPITAL_ADJUSTMENT_ROW = 'NET_WORKING_CAPITAL_ADJUSTMENT_ROW',
	NET_WORKING_CAPITAL_ADJUSTMENT_LABEL = 'NET_WORKING_CAPITAL_ADJUSTMENT_LABEL',
	NET_WORKING_CAPITAL_ADJUSTMENT_TOTAL_VALUE = 'NET_WORKING_CAPITAL_ADJUSTMENT_TOTAL_VALUE',
	NET_WORKING_CAPITAL_ADJUSTMENT_CONVERTED_AMOUNT = 'NET_WORKING_CAPITAL_ADJUSTMENT_CONVERTED_AMOUNT',
	TOTAL_EQUITY_VALUE_ADJUSTMENT_CONVERTED = 'TOTAL_EQUITY_VALUE_ADJUSTMENT_CONVERTED',
	TOTAL_ENTERPRISE_VALUE_CONVERTED = 'TOTAL_ENTERPRISE_VALUE_CONVERTED',
	TOTAL_ENTERPRISE_VALUE_SWITCH_LABEL = 'TOTAL_ENTERPRISE_VALUE_SWITCH_LABEL',
	TOTAL_EQUITY_VALUE_SWITCH_LABEL = 'TOTAL_EQUITY_VALUE_SWITCH_LABEL',
	INPUT_AMOUNT_LABEL = 'INPUT_AMOUNT_LABEL',
	CONVERTED_AMOUNT_LABEL = 'CONVERTED_AMOUNT_LABEL',
	FX_EXCHANGE_RATE_ROW = 'FX_EXCHANGE_RATE_ROW',
	FX_EXCHANGE_RATE_CURRENCY_WITH_FLAG = 'FX_EXCHANGE_RATE_CURRENCY_WITH_FLAG',
	FX_EXCHANGE_LIVE_RATE = 'FX_EXCHANGE_LIVE_RATE',
	FX_EXCHANGE_RATE_AT_VALUATION = 'FX_EXCHANGE_RATE_AT_VALUATION',
	FX_EXCHANGE_RATE_AT_VALUATION_SAVE = 'FX_EXCHANGE_RATE_AT_VALUATION_SAVE',
	FX_EXCHANGE_RATE_AT_VALUATION_CANCEL = 'FX_EXCHANGE_RATE_AT_VALUATION_CANCEL',
	FX_EXCHANGE_RATE_AT_VALUATION_EDIT = 'FX_EXCHANGE_RATE_AT_VALUATION_EDIT',
	FX_EXCHANGE_RATE_AT_VALUATION_EDIT_INPUT = 'FX_EXCHANGE_RATE_AT_VALUATION_EDIT_INPUT',
	FX_EXCHANGE_RATE_AT_VALUATION_RESET = 'FX_EXCHANGE_RATE_AT_VALUATION_RESET',
	FX_EXCHANGE_DEFAULT_CURRENCY = 'FX_EXCHANGE_DEFAULT_CURRENCY',
	FX_EXCHANGE_DRAWER_VALUATION_DATE = 'FX_EXCHANGE_DRAWER_VALUATION_DATE',
	FX_EXCHANGE_DRAWER_CANCEL_BUTTON = 'FX_EXCHANGE_DRAWER_CANCEL_BUTTON',
	FX_EXCHANGE_DRAWER_SAVE_BUTTON = 'FX_EXCHANGE_DRAWER_SAVE_BUTTON',
	FX_EXCHANGE_LIVE_RATE_VALUE = 'FX_EXCHANGE_LIVE_RATE_VALUE',
	FX_EXCHANGE_LIVE_RATE_AT_VALUATION_DATE = 'FX_EXCHANGE_LIVE_RATE_AT_VALUATION_DATE',
}

export enum IBAN_COMPONENT_ELEMENT_ID {
	ACCOUNT_HOLDER_INPUT = 'ACCOUNT_HOLDER_INPUT',
	BANK_NAME_INPUT = 'BANK_NAME_INPUT',
	SWIFT_BIC_INPUT = 'SWIFT_BIC_INPUT',
	INSTRUCTIONS_INPUT = 'INSTRUCTIONS_INPUT',
	ACCOUNT_NUMBER_INPUT = 'ACCOUNT_NUMBER_INPUT',
	VALIDATED_IBAN_SUBMIT_BUTTON = 'VALIDATED_IBAN_SUBMIT_BUTTON',
	VALIDATED_IBAN_RESET_BUTTON = 'VALIDATED_IBAN_RESET_BUTTON',
	CONFIRM_ACCOUNT_BUTTON = 'CONFIRM_ACCOUNT_BUTTON',

	IBAN_INPUT = 'IBAN_INPUT',
	LOOKUP_BUTTON = 'LOOKUP_BUTTON',
	IBAN_LOOKUP_LOADING = 'IBAN_LOOKUP_LOADING',
	IBAN_LOOKUP_SUMMARY = 'IBAN_LOOKUP_SUMMARY',
	IBAN_LOOKUP_ERROR = 'IBAN_LOOKUP_ERROR',
	IBAN_MANUAL_ENTRY_BUTTON = 'IBAN_MANUAL_ENTRY_BUTTON',
	BANK_ACCOUNT_TILE_COUNTRY_FLAG = 'BANK_ACCOUNT_TILE_COUNTRY_FLAG',
	BANK_RULE_VERIFY_BUTTON = 'BANK_RULE_VERIFY_BUTTON',
	BANK_RULE_VERIFY_LOADING = 'BANK_RULE_VERIFY_LOADING',
	BANK_RULE_VERIFY_SUMMARY = 'BANK_RULE_VERIFY_SUMMARY',
	BANK_RULE_STORED_SUMMARY = 'BANK_RULE_STORED_SUMMARY',
	BANK_RULE_VERIFY_ERROR = 'BANK_RULE_VERIFY_ERROR',
	CLEAR_AND_REENTER_BUTTON = 'CLEAR_AND_REENTER_BUTTON',
	ACCOUNT_NAME_INPUT = 'ACCOUNT_NAME_INPUT',
	BIC_INPUT = 'BIC_INPUT',
	BANK_COUNTRY_INPUT = 'BANK_COUNTRY_INPUT',
	BANK_CURRENCY_INPUT = 'BANK_CURRENCY_INPUT',
	BANK_FORMAT_INPUT = 'BANK_FORMAT_INPUT',
	BANK_FORMATS_ERROR = 'BANK_FORMATS_ERROR',
	BANK_DYNAMIC_FIELD_INPUT = 'BANK_DYNAMIC_FIELD_INPUT',
	BANK_COUNTRY_SUMMARY = 'BANK_COUNTRY_SUMMARY',
	BANK_COUNTRY_CHANGE_BUTTON = 'BANK_COUNTRY_CHANGE_BUTTON',
	BANK_COUNTRY_SEARCH_INPUT = 'BANK_COUNTRY_SEARCH_INPUT',
	BANK_COUNTRY_OPTION = 'BANK_COUNTRY_OPTION',
	BANK_COUNTRY_CONTINUE_BUTTON = 'BANK_COUNTRY_CONTINUE_BUTTON',
	BANK_COUNTRY_BACK_BUTTON = 'BANK_COUNTRY_BACK_BUTTON',
	BANK_CANCEL_BUTTON = 'BANK_CANCEL_BUTTON',
	NO_ACCOUNT_ALERT_WRAPPER = 'NO_ACCOUNT_ALERT_WRAPPER',
	SUBMIT_BUTTON = 'SUBMIT_BUTTON',

	VERIFY_CODE_BUTTON = 'VERIFY_CODE_BUTTON',
	PENDING_CONFIRMATION_ALERT = 'PENDING_CONFIRMATION_ALERT',
	INVALID_CODE_TOAST = 'INVALID_CODE_TOAST',
	UPDATE_BANK_ACCOUNT_SUCCESS_TOAST = 'UPDATE_BANK_ACCOUNT_SUCCESS_TOAST',
}

export enum COUNTERPARTIES_COMPONENT_ELEMENT_ID {
	MIP_CREATE_COUNTERPARTIES_ADD_ANOTHER = 'MIP_CREATE_COUNTERPARTIES_ADD_ANOTHER',
	MIP_CREATE_COUNTERPARTIES_SAVE_BUTTON = 'MIP_CREATE_COUNTERPARTIES_SAVE_BUTTON',
	MIP_CREATE_COUNTERPARTIES_CANCEL_BUTTON = 'MIP_CREATE_COUNTERPARTIES_CANCEL_BUTTON',
	MIP_CREATE_COUNTERPARTIES_SIGNATORIES = 'MIP_CREATE_COUNTERPARTIES_SIGNATORIES',
	MIP_CREATE_COUNTERPARTIES_NAME_INPUT = 'MIP_CREATE_COUNTERPARTIES_NAME_INPUT',
	MIP_CREATE_COUNTERPARTIES_SAVE_BUTTON_SQUARE = 'MIP_CREATE_COUNTERPARTIES_SAVE_BUTTON_SQUARE',
	MIP_CREATE_COUNTERPARTIES_CLOSE_BUTTON_SQUARE = 'MIP_CREATE_COUNTERPARTIES_CLOSE_BUTTON_SQUARE',
	MIP_CREATE_COUNTERPARTIES_DELETE_BUTTON_SQUARE = 'MIP_CREATE_COUNTERPARTIES_DELETE_BUTTON_SQUARE',
}

export enum ADDRESS_COMPONENT_ELEMENT_ID {
	INVESTOR_ADDRESS_COUNTRY = 'INVESTOR_ADDRESS_COUNTRY',
	INVESTOR_ADDRESS_CITY = 'INVESTOR_ADDRESS_CITY',
	INVESTOR_ADDRESS_STREET = 'INVESTOR_ADDRESS_STREET',
	INVESTOR_ADDRESS_HOUSE_NUMBER = 'INVESTOR_ADDRESS_HOUSE_NUMBER',
	INVESTOR_ADDRESS_POST_CODE = 'INVESTOR_ADDRESS_POST_CODE',
}

export enum DOCUMENT_WORKFLOW {
	MODAL = 'SEND_DOCUMENT_MODAL',
	TITLE = 'SEND_DOCUMENT_TITLE',
	CLOSE = 'SEND_DOCUMENT_CLOSE',
	SELECT_LABEL = 'SEND_DOCUMENT_SELECT_LABEL',
	DOCUMENT_NAME = 'SEND_DOCUMENT_NAME',
	SEND_DOCUMENT_BUTTON = 'SEND_DOCUMENT_BUTTON',
	CUSTOM_MESSAGE_INPUT = 'CUSTOM_MESSAGE_INPUT',
}

export enum INVESTOR_TEST_ELEMENT_ID {
	ACCEPT_INVITATION_FIRST_NAME_INPUT = 'ACCEPT_INVITATION_FIRST_NAME_INPUT',
	ACCEPT_INVITATION_LAST_NAME_INPUT = 'ACCEPT_INVITATION_LAST_NAME_INPUT',
	ACCEPT_INVITATION_EMAIL = 'ACCEPT_INVITATION_EMAIL',
	ACCEPT_INVITATION_PHONE_NUMBER_INPUT = 'ACCEPT_INVITATION_PHONE_NUMBER_INPUT',
	ACCEPT_INVITATION_SIGNUP_BUTTON = 'ACCEPT_INVITATION_SIGNUP_BUTTON',
	ACCEPT_INVITATION_TERMS_CHECKBOX = 'ACCEPT_INVITATION_TERMS_CHECKBOX',
	ACCEPT_INVITATION_BACK_TO_LOGIN = 'ACCEPT_INVITATION_BACK_TO_LOGIN',
	INVESTOR_VIEW_INVESTMENT_BUTTON = 'INVESTOR_VIEW_INVESTMENT_BUTTON',
	INVESTOR_GET_STARTED_BUTTON = 'INVESTOR_GET_STARTED_BUTTON',
	INVESTOR_CONTINUE_BUTTON = 'INVESTOR_CONTINUE_BUTTON',
	INVESTOR_SAVE_BUTTON = 'INVESTOR_SAVE_BUTTON',
	INVESTOR_BACK_TO_DASHBOARD_BUTTON = 'INVESTOR_BACK_TO_DASHBOARD_BUTTON',
	INVESTOR_PREVIOUS_STEP_BUTTON = 'INVESTOR_PREVIOUS_STEP_BUTTON',
	INVESTOR_NEXT_STEP_BUTTON = 'INVESTOR_NEXT_STEP_BUTTON',
	INVESTOR_WIZARD_STEP_INDICATOR = 'INVESTOR_WIZARD_STEP_INDICATOR',
	INVESTOR_GROUP_WRAPPER_ERROR_TEXT = 'INVESTOR_GROUP_WRAPPER_ERROR_TEXT',
	INVESTOR_CARD_HEADER_STATUS = 'INVESTOR_CARD_HEADER_STATUS',
	INVESTOR_CARD_BUTTON_TEXT = 'INVESTOR_CARD_BUTTON_TEXT',
	INVESTOR_CARD_BUTTON_ARROW = 'INVESTOR_CARD_BUTTON_ARROW',
	INVESTOR_PERSONAL_INFORMATION_FIRST_NAME = 'INVESTOR_PERSONAL_INFORMATION_FIRST_NAME',
	INVESTOR_PERSONAL_INFORMATION_LAST_NAME = 'INVESTOR_PERSONAL_INFORMATION_LAST_NAME',
	INVESTOR_PERSONAL_INFORMATION_BIRTH_DATE = 'INVESTOR_PERSONAL_INFORMATION_BIRTH_DATE',
	INVESTOR_PERSONAL_INFORMATION_PHONE_NUMBER = 'INVESTOR_PERSONAL_INFORMATION_PHONE_NUMBER',
	INVESTOR_PERSONAL_INFORMATION_IS_PIV_CHECKBOX = 'INVESTOR_PERSONAL_INFORMATION_IS_PIV_CHECKBOX',
	INVESTOR_PERSONAL_INFORMATION_PIV_NAME = 'INVESTOR_PERSONAL_INFORMATION_PIV_NAME',
	INVESTOR_PERSONAL_INFORMATION_PIV_REG_NUMBER = 'INVESTOR_PERSONAL_INFORMATION_PIV_REG_NUMBER',
	INVESTOR_PERSONAL_INFORMATION_IS_REPRESENTATIVE_SAME_AS_INVESTOR = 'INVESTOR_PERSONAL_INFORMATION_IS_REPRESENTATIVE_SAME_AS_INVESTOR',
	INVESTOR_PERSONAL_INFORMATION_REPRESENTATIVE_FIRST_NAME = 'INVESTOR_PERSONAL_INFORMATION_REPRESENTATIVE_FIRST_NAME',
	INVESTOR_PERSONAL_INFORMATION_REPRESENTATIVE_LAST_NAME = 'INVESTOR_PERSONAL_INFORMATION_REPRESENTATIVE_LAST_NAME',
	INVESTOR_PERSONAL_INFORMATION_REPRESENTATIVE_EMAIL = 'INVESTOR_PERSONAL_INFORMATION_REPRESENTATIVE_EMAIL',
	INVESTOR_ADDRESS_INPUTS = 'INVESTOR_ADDRESS_INPUTS',
	INVESTOR_HOLDINGS_TABLE = 'INVESTOR_HOLDINGS_TABLE',
	INVESTOR_HOLDINGS_TABLE_VESTING_ICON = 'INVESTOR_HOLDINGS_TABLE_VESTING_ICON',
	INVESTOR_PIV_ADDRESS_INPUTS = 'INVESTOR_PIV_ADDRESS_INPUTS',
	INVESTOR__PERSONAL_DETAILS_OTHER = 'INVESTOR__PERSONAL_DETAILS_OTHER',
	INVESTOR_PIV_PERSONAL_DETAILS_OTHER = 'INVESTOR_PIV_PERSONAL_DETAILS_OTHER',
	INVESTOR_KYC_FORM_COMPLETE_FORM_BUTTON = 'INVESTOR_KYC_FORM_COMPLETE_FORM_BUTTON',
	INVESTOR_KYC_FORM_DOWNLOAD_DOCUMENT = 'INVESTOR_KYC_FORM_DOWNLOAD_DOCUMENT',
	INVESTOR_KYC_FORM_SAVE_BUTTON = 'INVESTOR_KYC_FORM_SAVE_BUTTON',
	INVESTOR_KYC_FORM_DOWNLOAD_CLEAN_COPY = 'INVESTOR_KYC_FORM_DOWNLOAD_CLEAN_COPY',
	INVESTOR_KYC_ID_UPLOAD = 'INVESTOR_KYC_ID_UPLOAD ',
	INVESTOR_KYC_ID_FILE_INPUT = 'INVESTOR_KYC_ID_FILE_INPUT',
	INVESTOR_KYC_ADDRESS_UPLOAD = 'INVESTOR_KYC_ADDRESS_UPLOAD',
	INVESTOR_KYC_ADDRESS_FILE_INPUT = 'INVESTOR_KYC_ADDRESS_FILE_INPUT',
	INVESTOR_KYC_FORM_UPLOAD_BUTTON = 'INVESTOR_KYC_FORM_UPLOAD_BUTTON',
	INVESTOR_KYC_FORM_DONE_BUTTON = 'INVESTOR_KYC_FORM_DONE_BUTTON',
	INVESTOR_KYC_INHERITED_CONFIRM_BUTTON = 'INVESTOR_KYC_INHERITED_CONFIRM_BUTTON',
	INVESTOR_KYC_CERTIFICATION_CHOICE = 'INVESTOR_KYC_CERTIFICATION_CHOICE',
	INVESTOR_KYC_CERTIFICATION_MODE_SELF_ATTESTED = 'INVESTOR_KYC_CERTIFICATION_MODE_SELF_ATTESTED',
	INVESTOR_KYC_CERTIFICATION_MODE_CERTIFIER = 'INVESTOR_KYC_CERTIFICATION_MODE_CERTIFIER',
	INVESTOR_KYC_CERTIFICATION_ATTESTED = 'INVESTOR_KYC_CERTIFICATION_ATTESTED',
	INVESTOR_KYC_CERTIFICATION_CERTIFIER_NAME = 'INVESTOR_KYC_CERTIFICATION_CERTIFIER_NAME',
	INVESTOR_KYC_CERTIFICATION_CERTIFIER_EMAIL = 'INVESTOR_KYC_CERTIFICATION_CERTIFIER_EMAIL',
	INVESTOR_KYC_CERTIFICATION_STATUS = 'INVESTOR_KYC_CERTIFICATION_STATUS',
	INVESTOR_KYC_CERTIFICATION_RESEND = 'INVESTOR_KYC_CERTIFICATION_RESEND',
	INVESTOR_KYC_CERTIFICATION_CHANGE = 'INVESTOR_KYC_CERTIFICATION_CHANGE',
	INVESTOR_KYC_CERTIFICATION_MODAL = 'INVESTOR_KYC_CERTIFICATION_MODAL',
	INVESTOR_KYC_CERTIFICATION_MODAL_SAVE = 'INVESTOR_KYC_CERTIFICATION_MODAL_SAVE',
	INVESTOR_KYC_INHERITED_DISMISS_BUTTON = 'INVESTOR_KYC_INHERITED_DISMISS_BUTTON',
	INVESTOR_DECLARATIONS_BENEFICIAL_OWNERSHIP_CHECKBOX = 'INVESTOR_DECLARATIONS_BENEFICIAL_OWNERSHIP_CHECKBOX',
	INVESTOR_DECLARATIONS_SOURCE_OF_FUNDS_CHECKBOX = 'INVESTOR_DECLARATIONS_SOURCE_OF_FUNDS_CHECKBOX',
	SOURCE_OF_FUNDS_SALARY_CHECKBOX = 'SOURCE_OF_FUNDS_SALARY_CHECKBOX',
	SOURCE_OF_FUNDS_INHERITANCE_CHECKBOX = 'SOURCE_OF_FUNDS_INHERITANCE_CHECKBOX',
	SOURCE_OF_FUNDS_INVESTMENT_INCOME_CHECKBOX = 'SOURCE_OF_FUNDS_INVESTMENT_INCOME_CHECKBOX',
	SOURCE_OF_FUNDS_PERSONAL_SAVINGS_CHECKBOX = 'SOURCE_OF_FUNDS_PERSONAL_SAVINGS_CHECKBOX',
	SOURCE_OF_FUNDS_OTHER_CHECKBOX = 'SOURCE_OF_FUNDS_OTHER_CHECKBOX',
	INVESTOR_DECLARATIONS_PEP_PERSON_CHECKBOX = 'INVESTOR_DECLARATIONS_PEP_PERSON_CHECKBOX',
	NOT_PEP_CHECKBOX = 'NOT_PEP_CHECKBOX',
	IS_PEP_CHECKBOX = 'IS_PEP_CHECKBOX',
	INVESTOR_DECLARATIONS_SOURCE_OF_FUNDS_OTHER_DETAILS = 'INVESTOR_DECLARATIONS_SOURCE_OF_FUNDS_OTHER_DETAILS',
	INVESTOR_DECLARATIONS_PEP_PERSON_DETAILS = 'INVESTOR_DECLARATIONS_PEP_PERSON_DETAILS',
	USER_PROFILE_BACK_TO_INVESTOR_BUTTON = 'USER_PROFILE_BACK_TO_INVESTOR_BUTTON',
	USER_PROFILE_SIDEBAR_MENU_PERSONAL_DETAILS = 'USER_PROFILE_SIDEBAR_MENU_PERSONAL_DETAILS',
	USER_PROFILE_SIDEBAR_MENU_BANKING_DETAILS = 'USER_PROFILE_SIDEBAR_MENU_BANKING_DETAILS',
	USER_PROFILE_SIDEBAR_MENU_ACCOUNT_SETTINGS = 'USER_PROFILE_SIDEBAR_MENU_ACCOUNT_SETTINGS',
	USER_PROFILE_SIDEBAR_MENU_PIV_DETAILS = 'USER_PROFILE_SIDEBAR_MENU_PIV_DETAILS',
	USER_PROFILE_PERSONAL_DETAILS_FIRST_NAME = 'USER_PROFILE_PERSONAL_DETAILS_FIRST_NAME',
	USER_PROFILE_PERSONAL_DETAILS_LAST_NAME = 'USER_PROFILE_PERSONAL_DETAILS_LAST_NAME',
	USER_PROFILE_PERSONAL_DETAILS_BIRTHDATE = 'USER_PROFILE_PERSONAL_DETAILS_BIRTHDATE',
	USER_PROFILE_PERSONAL_DETAILS_PHONE_NUMBER = 'USER_PROFILE_PERSONAL_DETAILS_PHONE_NUMBER',
	USER_PROFILE_PERSONAL_DETAILS_HOUSE_NUMBER = 'USER_PROFILE_PERSONAL_DETAILS_HOUSE_NUMBER',
	USER_PROFILE_PERSONAL_DETAILS_STREET = 'USER_PROFILE_PERSONAL_DETAILS_STREET',
	USER_PROFILE_PERSONAL_DETAILS_CITY = 'USER_PROFILE_PERSONAL_DETAILS_CITY',
	USER_PROFILE_PERSONAL_DETAILS_COUNTRY = 'USER_PROFILE_PERSONAL_DETAILS_COUNTRY',
	USER_PROFILE_PERSONAL_DETAILS_POSTCODE = 'USER_PROFILE_PERSONAL_DETAILS_POSTCODE',
	USER_PROFILE_PERSONAL_DETAILS_EDIT_BUTTON = 'USER_PROFILE_PERSONAL_DETAILS_EDIT_BUTTON',
	USER_PROFILE_PERSONAL_DETAILS_SAVE_BUTTON = 'USER_PROFILE_PERSONAL_DETAILS_SAVE_BUTTON',
	USER_PROFILE_PERSONAL_DETAILS_CANCEL_BUTTON = 'USER_PROFILE_PERSONAL_DETAILS_CANCEL_BUTTON',
	USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_EDIT_BUTTON = 'USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_EDIT_BUTTON',
	USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_SAVE_BUTTON = 'USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_SAVE_BUTTON',
	USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_CANCEL_BUTTON = 'USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_CANCEL_BUTTON',
	USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_COMPANY_NAME = 'USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_COMPANY_NAME',
	USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_COMPANY_NUMBER = 'USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_COMPANY_NUMBER',
	USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_HOUSE_NUMBER = 'USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_HOUSE_NUMBER',
	USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_STREET = 'USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_STREET',
	USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_CITY = 'USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_CITY',
	USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_COUNTRY = 'USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_COUNTRY',
	USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_POSTCODE = 'USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_POSTCODE',
	USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_REPRESENTATIVE_FIRST_NAME = 'USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_REPRESENTATIVE_FIRST_NAME',
	USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_REPRESENTATIVE_LAST_NAME = 'USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_REPRESENTATIVE_LAST_NAME',
	USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_REPRESENTATIVE_BIRTHDATE = 'USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_REPRESENTATIVE_BIRTHDATE',
	USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_REPRESENTATIVE_MAIL = 'USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_REPRESENTATIVE_MAIL',
	USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_REPRESENTATIVE_PHONE = 'USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_REPRESENTATIVE_PHONE',
	USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_REPRESENTATIVE_HOUSE_NUMBER = 'USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_REPRESENTATIVE_HOUSE_NUMBER',
	USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_REPRESENTATIVE_STREET = 'USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_REPRESENTATIVE_STREET',
	USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_REPRESENTATIVE_CITY = 'USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_REPRESENTATIVE_CITY',
	USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_REPRESENTATIVE_COUNTRY = 'USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_REPRESENTATIVE_COUNTRY',
	USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_REPRESENTATIVE_POSTALCODE = 'USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_REPRESENTATIVE_POSTALCODE',
	USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_REPRESENTATIVE_CANCEL_BUTTON = 'USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_REPRESENTATIVE_CANCEL_BUTTON',
	USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_REPRESENTATIVE_SAVE_BUTTON = 'USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_REPRESENTATIVE_SAVE_BUTTON',
	USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_REPRESENTATIVE_EDIT_BUTTON = 'USER_PROFILE_INVESTMENT_VEHICLE_DETAILS_REPRESENTATIVE_EDIT_BUTTON',
	INVESTOR_KYC_REJECTED_FILE_REMOVE_BUTTON = 'INVESTOR_KYC_REJECTED_FILE_REMOVE_BUTTON',
	INVESTOR_MANAGE_FINISH_GO_TO_DASHBOARD_BUTTON = 'INVESTOR_MANAGE_FINISH_GO_TO_DASHBOARD_BUTTON',
}

export enum ORGANIZATION_ELEMENT_ID {
	GENERAL_SETTINGS_UPDATE_BUTTON = 'ORG_GENERAL_SETTINGS_UPDATE_BUTTON',
	GENERAL_SETTINGS_NAME_INPUT = 'ORG_GENERAL_SETTINGS_NAME_INPUT',
	GENERAL_SETTINGS_CONTACT_EMAIL_INPUT = 'ORG_GENERAL_SETTINGS_CONTACT_EMAIL_INPUT',
	GENERAL_SETTINGS_TYPE_INPUT = 'ORG_GENERAL_SETTINGS_TYPE_INPUT',
	MINI_LIST_CARD_INVITE_USER_BUTTON = 'ORG_MINI_LIST_CARD_INVITE_USER_BUTTON',
	TABLED_ROW_INVITE = 'ORG_TABLED_ROW_INVITE',
	INVITE_MEMBER_FIRST_NAME_INPUT = 'ORG_INVITE_MEMBER_FIRST_NAME_INPUT',
	INVITE_MEMBER_LAST_NAME_INPUT = 'ORG_INVITE_MEMBER_LAST_NAME_INPUT',
	INVITE_MEMBER_EMAIL_INPUT = 'ORG_INVITE_MEMBER_EMAIL_INPUT',
	INVITE_MEMBER_SEND_BUTTON = 'ORG_INVITE_MEMBER_SEND_BUTTON',
	USER_ROW = 'organization-user-row',
	USER_ROW_RESEND_INVITATION = 'USER_ROW_RESEND_INVITATION',
}

export enum GENERIC_ELEMENT_ID {
	MANTINE_TABLE_FILTER_TOGGLE = 'MANTINE_TABLE_FILTER_TOGGLE',
	MANTINE_TABLE_FULL_SCREEN_TOGGLE = 'MANTINE_TABLE_FULL_SCREEN_TOGGLE',
	MANTINE_TABLE_COLUMN_FILTER = 'MANTINE_TABLE_COLUMN_FILTER',
	MANTINE_TABLE_ROW = 'MANTINE_TABLE_ROW',
	MANTINE_TABLE_CELL = 'MANTINE_TABLE_CELL',
	TOOLTIP_WARNING_ICON = 'TOOLTIP_WARNING_ICON',
	ENTITY_SELECT = 'ENTITY_SELECT',
	QUICK_SWITCHER_TARGET = 'QUICK_SWITCHER_TARGET',
	QUICK_SWITCHER_MENU_CAP_TABLE = 'QUICK_SWITCHER_MENU_CAP_TABLE',
	QUICK_SWITCHER_MENU_GSC = 'QUICK_SWITCHER_MENU_GSC',
	QUICK_SWITCHER_MENU_DEAL_DIRECTORY = 'QUICK_SWITCHER_MENU_DEAL_DIRECTORY',
	QUICK_SWITCHER_MENU_VALUATION = 'QUICK_SWITCHER_MENU_VALUATION',
	QUICK_SWITCHER_MENU_EVENT_LOG = 'QUICK_SWITCHER_MENU_EVENT_LOG',
	QUICK_SWITCHER_MENU_ITEM_BADGE = 'QUICK_SWITCHER_MENU_ITEM_BADGE',
	DEAL_EVENT_LOG_SEEN_MARKER = 'DEAL_EVENT_LOG_SEEN_MARKER',
	CONFIRM_DELETE_DRAWER_INPUT = 'CONFIRM_DELETE_DRAWER_INPUT',
	CONFIRM_DELETE_DRAWER_DELETE_BUTTON = 'CONFIRM_DELETE_DRAWER_DELETE_BUTTON',
	CONFIRM_DELETE_DRAWER_CANCEL_BUTTON = 'CONFIRM_DELETE_DRAWER_CANCEL_BUTTON',
	CONFIRM_DELETE_DRAWER_HEADING = 'CONFIRM_DELETE_DRAWER_HEADING',
	CONFIRM_DELETE_DRAWER_CONFIRM_TEXT = 'CONFIRM_DELETE_DRAWER_CONFIRM_TEXT',
	VERIFICATION_CODE = 'VERIFICATION_CODE',
	LANGUAGE_PICKER = 'LANGUAGE_PICKER',
	USER_DROPDOWN = 'USER_DROPDOWN',
	RANK_SECURITY_DROPDOWN = 'RANK_SECURITY_DROPDOWN',
	SWITCH_SECURITY_RANK_DROPDOWN = 'SWITCH_SECURITY_RANK_DROPDOWN',
	SELECT_OPTION = 'SELECT_OPTION',
	VESTED_PERCENTAGE_TEXT = 'VESTED_PERCENTAGE_TEXT',
}

export enum INVESTOR_MESSAGES_TEST_ID {
	MESSAGE_LIST = 'MESSAGE_LIST',
	MESSAGE_LIST_ITEM = 'MESSAGE_LIST_ITEM',
	MESSAGE_LIST_ITEM_HEADER = 'MESSAGE_LIST_ITEM_HEADER',
	MESSAGE_LIST_ITEM_STATUS = 'MESSAGE_LIST_ITEM_STATUS',
	MESSAGE_SEARCH_INPUT = 'MESSAGE_SEARCH_INPUT',
	MESSAGE_LIST_LOADING = 'MESSAGE_LIST_LOADING',
	MESSAGE_LIST_EMPTY = 'MESSAGE_LIST_EMPTY',
	MESSAGE_LIST_CONTAINER = 'MESSAGE_LIST_CONTAINER',
}

export enum DOCUMENT_LIBRARY_ELEMENT_ID {
	// Document Library page
	ADD_TO_LIBRARY_BUTTON = 'ADD_TO_LIBRARY_BUTTON',
	DOCUMENTS_TABLE = 'DOCUMENTS_TABLE',
	/** Suffixed with the document name. */
	DOCUMENT_ROW = 'DOCUMENT_ROW',
	EDIT_PANEL_TITLE = 'EDIT_PANEL_TITLE',

	// Upload wizard - shared with the deal directory and the transaction link modal
	UPLOAD_ADD_FILES_STEP = 'UPLOAD_ADD_FILES_STEP',
	UPLOAD_VALIDATE_FILES_STEP = 'UPLOAD_VALIDATE_FILES_STEP',
	UPLOAD_FILE_ASSOCIATION_STEP = 'UPLOAD_FILE_ASSOCIATION_STEP',
	UPLOAD_COMPLETE_STEP = 'UPLOAD_COMPLETE_STEP',
	/** Suffixed with the classifier name. */
	UPLOAD_CLASSIFIER_DROPZONE = 'UPLOAD_CLASSIFIER_DROPZONE',
	UPLOAD_UNCLASSIFIED_DROPZONE = 'UPLOAD_UNCLASSIFIED_DROPZONE',
	UPLOAD_CLASSIFIERS_EMPTY_STATE = 'UPLOAD_CLASSIFIERS_EMPTY_STATE',
	UPLOAD_SELECTED_FILES = 'UPLOAD_SELECTED_FILES',
	/** Suffixed with the file name. */
	UPLOAD_SELECTED_FILE = 'UPLOAD_SELECTED_FILE',
	/** Suffixed with the file name. */
	UPLOAD_SELECTED_FILE_CLASSIFIER = 'UPLOAD_SELECTED_FILE_CLASSIFIER',
	/** Suffixed with the file name. */
	UPLOAD_SELECTED_FILE_REMOVE = 'UPLOAD_SELECTED_FILE_REMOVE',
	/**
	 * The stat's number on its own, so a count can be asserted exactly. Suffixed with the stat
	 * key - uploaded, unique, duplicates, already_in_deal, linked.
	 */
	UPLOAD_STAT_VALUE = 'UPLOAD_STAT_VALUE',
	UPLOAD_CONTINUE_BUTTON = 'UPLOAD_CONTINUE_BUTTON',
	UPLOAD_CANCEL_BUTTON = 'UPLOAD_CANCEL_BUTTON',
	/** Suffixed with the file name. */
	UPLOAD_DUPLICATE_CANDIDATE = 'UPLOAD_DUPLICATE_CANDIDATE',
	/** Suffixed with the file name. */
	UPLOAD_DUPLICATE_CANDIDATE_RADIO = 'UPLOAD_DUPLICATE_CANDIDATE_RADIO',
	/** Suffixed with the existing document name. */
	UPLOAD_EXISTING_FILE_CARD = 'UPLOAD_EXISTING_FILE_CARD',
	/** Suffixed with the existing document name. */
	UPLOAD_EXISTING_FILE_VIEW_DOCUMENT = 'UPLOAD_EXISTING_FILE_VIEW_DOCUMENT',
	/** The records the upload was started from, always linked. */
	UPLOAD_SOURCE_RECORDS = 'UPLOAD_SOURCE_RECORDS',
	/** Other records matching the source that the user may also link. */
	UPLOAD_LINKABLE_RECORDS = 'UPLOAD_LINKABLE_RECORDS',
	UPLOAD_LINKABLE_RECORDS_DATE = 'UPLOAD_LINKABLE_RECORDS_DATE',
	UPLOAD_COMPLETE_CONFIRM_BUTTON = 'UPLOAD_COMPLETE_CONFIRM_BUTTON',

	// Document edit panel. The field components are shared with the deal directory and the
	// transaction document drawer, so these anchors appear on three surfaces.
	EDIT_PANEL_CLOSE = 'EDIT_PANEL_CLOSE',
	EDIT_PANEL_DOWNLOAD_BUTTON = 'EDIT_PANEL_DOWNLOAD_BUTTON',
	EDIT_PANEL_MANAGE_TRANSACTIONS_BUTTON = 'EDIT_PANEL_MANAGE_TRANSACTIONS_BUTTON',
	EDIT_PANEL_DELETE_BUTTON = 'EDIT_PANEL_DELETE_BUTTON',
	/** Suffixed with the field key. */
	FIELD = 'FIELD',
	/** Suffixed with the field key. */
	FIELD_VALUE = 'FIELD_VALUE',
	/** Suffixed with the field key. Absent on a read-only field - assert absence, not disabled. */
	FIELD_EDIT_BUTTON = 'FIELD_EDIT_BUTTON',
	/** Suffixed with the field key. The list field's action, e.g. view all related people. */
	FIELD_ACTION_BUTTON = 'FIELD_ACTION_BUTTON',
	/** Suffixed with the field key. */
	FIELD_INPUT = 'FIELD_INPUT',
	FIELD_SAVE_BUTTON = 'FIELD_SAVE_BUTTON',
	FIELD_CANCEL_BUTTON = 'FIELD_CANCEL_BUTTON',
	/** Suffixed with the list item id. */
	LIST_ITEM = 'LIST_ITEM',
	/** Suffixed with the list item id. Deliberately not prefixed LIST_ITEM_, so counting rows
	 * by that prefix cannot pick up remove icons as well. */
	REMOVE_LIST_ITEM = 'REMOVE_LIST_ITEM',
	PERSONS_LIST = 'PERSONS_LIST',
	PERSONS_LIST_ADD_ANOTHER = 'PERSONS_LIST_ADD_ANOTHER',
	PERSONS_LIST_EDIT_BUTTON = 'PERSONS_LIST_EDIT_BUTTON',
	PERSONS_LIST_FIND_INPUT = 'PERSONS_LIST_FIND_INPUT',
	PERSONS_LIST_ADD_SELECT = 'PERSONS_LIST_ADD_SELECT',
	PERSONS_LIST_SAVE_BUTTON = 'PERSONS_LIST_SAVE_BUTTON',
	PERSONS_LIST_CANCEL_BUTTON = 'PERSONS_LIST_CANCEL_BUTTON',
	/** Suffixed with the transaction id. */
	RELATED_TO_LINK_BUTTON = 'RELATED_TO_LINK_BUTTON',
	RELATED_TO_UPDATE_BUTTON = 'RELATED_TO_UPDATE_BUTTON',
	RELATED_TO_CANCEL_BUTTON = 'RELATED_TO_CANCEL_BUTTON',
	ARCHIVE_PANEL_TITLE_INPUT = 'ARCHIVE_PANEL_TITLE_INPUT',
	ARCHIVE_PANEL_CONFIRM_BUTTON = 'ARCHIVE_PANEL_CONFIRM_BUTTON',
}

export const makeComplexDataTestId = (
	base:
		| TEST_ELEMENT_IDS
		| GENERIC_ELEMENT_ID
		| VALUATION_ELEMENT_ID
		| IBAN_COMPONENT_ELEMENT_ID
		| COUNTERPARTIES_COMPONENT_ELEMENT_ID
		| ADDRESS_COMPONENT_ELEMENT_ID
		| DOCUMENT_WORKFLOW
		| INVESTOR_TEST_ELEMENT_ID
		| ORGANIZATION_ELEMENT_ID
		| INVESTOR_MESSAGES_TEST_ID
		| DOCUMENT_LIBRARY_ELEMENT_ID,
	suffix?: string | null
) => `${base}_${suffix?.trim().replace(/\s+/g, '_')}`;
